<template>
  <div>
    <div class="wrapper">
      <comheader :index="3"></comheader>
      <main id="content" role="main">
        <input type="hidden" name="hdnAgeText" id="hdnAgeText" value="Age" />
        <input
          type="hidden"
          name="hdnDateTimeText"
          id="hdnDateTimeText"
          value="Date Time (UTC)"
        />
        <input
          type="hidden"
          name="hdnAgeTitle"
          id="hdnAgeTitle"
          value="Click to show Age Format"
        />
        <input
          type="hidden"
          name="hdnDateTimeTitle"
          id="hdnDateTimeTitle"
          value="Click to show Datetime Format"
        />
        <input
          type="hidden"
          name="hdnTxnText"
          id="hdnTxnText"
          value="Txn Fee"
        />
        <input
          type="hidden"
          name="hdnGasPriceText"
          id="hdnGasPriceText"
          value="Gas Price"
        />
        <input
          type="hidden"
          name="hdnTxnFeeTitle"
          id="hdnTxnFeeTitle"
          value="(Gas Price * Gas Used by Txns) in Ether"
        />
        <input
          type="hidden"
          name="hdnGasPriceTitle"
          id="hdnGasPriceTitle"
          value="Gas Price in Gwei"
        />
        <div class="container space-top-1 space-bottom-2">
          <div id="overlayMain" style="display: none"></div>
          <div class="text-center mb-3">
            <div class="w-md-75 w-lg-75 mx-md-auto">
              <h1 class="h4">Verify &amp; Publish Contract Source Code</h1>
              <span
                class="badge badge-primary py-2"
                style="
                  border-radius: 5rem;
                  padding-left: 15px;
                  padding-right: 15px;
                "
                >Compiler Type: SOLIDITY MULTI-PART VERIFIER (IMPORTS)</span
              >
            </div>
          </div>
          <div class="container">
            <div class="border-top py-3">
              <p class="mb-0">
                <span
                  class="
                    d-none d-md-inline-block
                    u-label u-label--price
                    rounded
                    mt-1
                    ml-n1
                  "
                  >Info:</span
                >
                This is an <b>experimental</b> source code verifier which
                supports verification of
                <b>multi-part solidity files</b> (imports).
              </p>
            </div>
          </div>
          <form
            method="post"
            action="./verifyContract-solc-multiple?a=0xEF19Dda5c6A8755F8D799C3EFcCF753Ad12a65a9&amp;c=v0.8.0%2bcommit.c7dfd78e&amp;lictype=1"
            onsubmit="javascript:return WebForm_OnSubmit();"
            id="ctl00"
            class="js-validate mt-2"
            autocomplete="off"
            enctype="multipart/form-data"
            novalidate="novalidate"
          >
            <div class="card">
              <div
                class="
                  card-header
                  d-flex
                  justify-content-between
                  align-items-center
                  p-0
                "
              >
                <ul
                  class="nav nav-custom nav-borderless nav-tabs1"
                  id="myTab"
                  role="tablist"
                >
                  <li class="nav-item" id="anchor1">
                    <a
                      class="nav-link active"
                      id="tab1"
                      data-toggle="tab"
                      href="#contractsource"
                      role="tab"
                      aria-controls="overview"
                      aria-selected="true"
                      >Contract Source Code</a
                    >
                  </li>
                </ul>
                <div class="mr-3">
                  <span id="spinwheel" style="display: none"
                    >... Processing, this can take up to 30 seconds ...</span
                  >
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content py-1 ml-1 mr-1">
                  <div class="tab-pane fade show active" id="contractsource">
                    <span
                      id="ContentPlaceHolder1_lblErrorStatus"
                      v-if="error_code == 500"
                      ><div class="alert alert-danger">
                        <strong>Error!</strong> {{ error_msg }}
                      </div></span
                    >
                    <div id="ContentPlaceHolder1_maindisplay">
                      <div
                        class="
                          alert alert-dark alert-dismissible
                          fade
                          show
                          font-size-1
                        "
                        style="background-color: #e9ecf1"
                      >
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                        <ul
                          class="
                            list-unstyled list-xs-space
                            alert-text
                            mb-0
                            mt-2
                          "
                        >
                          <li>
                            1. If it compiles correctly at
                            <a
                              rel="nofollow noopener"
                              href="https://remix.ethereum.org/"
                              target="_blank"
                              >REMIX</a
                            >, it should also compile correctly here.
                          </li>
                          <li>
                            2. As this is an beta release module, there is
                            limited support for external libraries
                          </li>
                          <li>
                            3. There is a timeout of up to 45 seconds for each
                            contract compiled, if you need longer compilation
                            times (up to 3 mins) check out this
                            <a
                              href="https://docs.etherscan.io/api-endpoints/contracts"
                              target="_blank"
                              >API endpoint</a
                            >
                          </li>
                        </ul>
                      </div>

                      <div class="row">
                        <div class="col-md-5 col-sm-12">
                          <div class="js-form-message form-group">
                            <label
                              for="txtContractAddress"
                              id="lblContractAddress"
                              >Contract Address
                            </label>
                            <div
                              class="
                                js-focus-state
                                input-group input-group-sm
                                mb-2
                              "
                            >
                              <input
                                name="ctl00$ContentPlaceHolder1$txtContractAddress"
                                type="text"
                                v-model="address"
                                maxlength="42"
                                readonly="readonly"
                                id="ContentPlaceHolder1_txtContractAddress"
                                class="form-control form-control-sm"
                                placeholder="0x..."
                                data-name="txtContractAddress"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5 col-sm-12">
                          <div class="js-form-message form-group">
                            <label
                              for="ddlCompilerVersions"
                              id="lblCompilerVersions"
                              >Compiler
                            </label>
                            <div
                              class="
                                js-focus-state
                                input-group input-group-sm
                                mb-2
                              "
                            >
                              <select
                                name="ctl00$ContentPlaceHolder1$ddlCompilerVersions"
                                id="ContentPlaceHolder1_ddlCompilerVersions"
                                disabled="disabled"
                                class="
                                  aspNetDisabled
                                  custom-select custom-select-sm
                                "
                                v-model="selectedVersion"
                              >
                                <option value="">[Please Select]</option>
                                <option
                                  value="v0.8.13-nightly.2022.3.15+commit.724af73f"
                                >
                                  v0.8.13-nightly.2022.3.15+commit.724af73f
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.14+commit.353759c1"
                                >
                                  v0.8.13-nightly.2022.3.14+commit.353759c1
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.11+commit.26963775"
                                >
                                  v0.8.13-nightly.2022.3.11+commit.26963775
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.10+commit.4263b893"
                                >
                                  v0.8.13-nightly.2022.3.10+commit.4263b893
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.9+commit.bebdccca"
                                >
                                  v0.8.13-nightly.2022.3.9+commit.bebdccca
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.7+commit.145186f6"
                                >
                                  v0.8.13-nightly.2022.3.7+commit.145186f6
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.4+commit.198b7053"
                                >
                                  v0.8.13-nightly.2022.3.4+commit.198b7053
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.3+commit.999a53c9"
                                >
                                  v0.8.13-nightly.2022.3.3+commit.999a53c9
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.2+commit.ebefb5d9"
                                >
                                  v0.8.13-nightly.2022.3.2+commit.ebefb5d9
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.3.1+commit.2bcb0275"
                                >
                                  v0.8.13-nightly.2022.3.1+commit.2bcb0275
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.28+commit.466251b5"
                                >
                                  v0.8.13-nightly.2022.2.28+commit.466251b5
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.24+commit.1aacb67a"
                                >
                                  v0.8.13-nightly.2022.2.24+commit.1aacb67a
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.23+commit.e7d93f83"
                                >
                                  v0.8.13-nightly.2022.2.23+commit.e7d93f83
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.22+commit.47d77931"
                                >
                                  v0.8.13-nightly.2022.2.22+commit.47d77931
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.21+commit.5db29076"
                                >
                                  v0.8.13-nightly.2022.2.21+commit.5db29076
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.17+commit.daad9a42"
                                >
                                  v0.8.13-nightly.2022.2.17+commit.daad9a42
                                </option>
                                <option
                                  value="v0.8.13-nightly.2022.2.16+commit.da50176b"
                                >
                                  v0.8.13-nightly.2022.2.16+commit.da50176b
                                </option>
                                <option value="v0.8.12+commit.f00d7308">
                                  v0.8.12+commit.f00d7308
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.15+commit.16983848"
                                >
                                  v0.8.12-nightly.2022.2.15+commit.16983848
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.14+commit.b3ccc013"
                                >
                                  v0.8.12-nightly.2022.2.14+commit.b3ccc013
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.10+commit.1210c3e6"
                                >
                                  v0.8.12-nightly.2022.2.10+commit.1210c3e6
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.9+commit.5539a745"
                                >
                                  v0.8.12-nightly.2022.2.9+commit.5539a745
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.8+commit.5c3bcb6c"
                                >
                                  v0.8.12-nightly.2022.2.8+commit.5c3bcb6c
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.7+commit.0e93456e"
                                >
                                  v0.8.12-nightly.2022.2.7+commit.0e93456e
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.4+commit.32d64ce6"
                                >
                                  v0.8.12-nightly.2022.2.4+commit.32d64ce6
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.3+commit.2b141c23"
                                >
                                  v0.8.12-nightly.2022.2.3+commit.2b141c23
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.2.1+commit.a05d2b35"
                                >
                                  v0.8.12-nightly.2022.2.1+commit.a05d2b35
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.31+commit.d839624f"
                                >
                                  v0.8.12-nightly.2022.1.31+commit.d839624f
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.29+commit.ef8911a6"
                                >
                                  v0.8.12-nightly.2022.1.29+commit.ef8911a6
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.27+commit.7a40785b"
                                >
                                  v0.8.12-nightly.2022.1.27+commit.7a40785b
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.26+commit.597426bd"
                                >
                                  v0.8.12-nightly.2022.1.26+commit.597426bd
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.25+commit.2725788c"
                                >
                                  v0.8.12-nightly.2022.1.25+commit.2725788c
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.21+commit.3f401ebd"
                                >
                                  v0.8.12-nightly.2022.1.21+commit.3f401ebd
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.20+commit.40d3223b"
                                >
                                  v0.8.12-nightly.2022.1.20+commit.40d3223b
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.19+commit.0b9ab33f"
                                >
                                  v0.8.12-nightly.2022.1.19+commit.0b9ab33f
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.18+commit.a07b3ec7"
                                >
                                  v0.8.12-nightly.2022.1.18+commit.a07b3ec7
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.17+commit.79e9d619"
                                >
                                  v0.8.12-nightly.2022.1.17+commit.79e9d619
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.14+commit.756ae673"
                                >
                                  v0.8.12-nightly.2022.1.14+commit.756ae673
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.13+commit.7c1daa50"
                                >
                                  v0.8.12-nightly.2022.1.13+commit.7c1daa50
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.12+commit.bc4436c5"
                                >
                                  v0.8.12-nightly.2022.1.12+commit.bc4436c5
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.11+commit.a7119699"
                                >
                                  v0.8.12-nightly.2022.1.11+commit.a7119699
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.10+commit.10c954fd"
                                >
                                  v0.8.12-nightly.2022.1.10+commit.10c954fd
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.6+commit.c3b4292d"
                                >
                                  v0.8.12-nightly.2022.1.6+commit.c3b4292d
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.5+commit.b6a203a9"
                                >
                                  v0.8.12-nightly.2022.1.5+commit.b6a203a9
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.4+commit.b892851d"
                                >
                                  v0.8.12-nightly.2022.1.4+commit.b892851d
                                </option>
                                <option
                                  value="v0.8.12-nightly.2022.1.3+commit.c28f85f1"
                                >
                                  v0.8.12-nightly.2022.1.3+commit.c28f85f1
                                </option>
                                <option
                                  value="v0.8.12-nightly.2021.12.30+commit.6849774b"
                                >
                                  v0.8.12-nightly.2021.12.30+commit.6849774b
                                </option>
                                <option
                                  value="v0.8.12-nightly.2021.12.29+commit.692614df"
                                >
                                  v0.8.12-nightly.2021.12.29+commit.692614df
                                </option>
                                <option
                                  value="v0.8.12-nightly.2021.12.22+commit.b28cd00a"
                                >
                                  v0.8.12-nightly.2021.12.22+commit.b28cd00a
                                </option>
                                <option
                                  value="v0.8.12-nightly.2021.12.21+commit.15826826"
                                >
                                  v0.8.12-nightly.2021.12.21+commit.15826826
                                </option>
                                <option
                                  value="v0.8.12-nightly.2021.12.20+commit.b65e0933"
                                >
                                  v0.8.12-nightly.2021.12.20+commit.b65e0933
                                </option>
                                <option value="v0.8.11+commit.d7f03943">
                                  v0.8.11+commit.d7f03943
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.12.16+commit.10289fbc"
                                >
                                  v0.8.11-nightly.2021.12.16+commit.10289fbc
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.12.15+commit.1822261d"
                                >
                                  v0.8.11-nightly.2021.12.15+commit.1822261d
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.12.3+commit.c76a6bdb"
                                >
                                  v0.8.11-nightly.2021.12.3+commit.c76a6bdb
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.12.1+commit.dcef56a5"
                                >
                                  v0.8.11-nightly.2021.12.1+commit.dcef56a5
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.30+commit.c04fca7c"
                                >
                                  v0.8.11-nightly.2021.11.30+commit.c04fca7c
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.29+commit.cb610b50"
                                >
                                  v0.8.11-nightly.2021.11.29+commit.cb610b50
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.25+commit.e0c85c6f"
                                >
                                  v0.8.11-nightly.2021.11.25+commit.e0c85c6f
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.23+commit.71f8576b"
                                >
                                  v0.8.11-nightly.2021.11.23+commit.71f8576b
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.22+commit.9b6a687a"
                                >
                                  v0.8.11-nightly.2021.11.22+commit.9b6a687a
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.18+commit.2aeeef83"
                                >
                                  v0.8.11-nightly.2021.11.18+commit.2aeeef83
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.16+commit.e5579526"
                                >
                                  v0.8.11-nightly.2021.11.16+commit.e5579526
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.11+commit.73344204"
                                >
                                  v0.8.11-nightly.2021.11.11+commit.73344204
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.10+commit.9240368e"
                                >
                                  v0.8.11-nightly.2021.11.10+commit.9240368e
                                </option>
                                <option
                                  value="v0.8.11-nightly.2021.11.9+commit.19159b96"
                                >
                                  v0.8.11-nightly.2021.11.9+commit.19159b96
                                </option>
                                <option value="v0.8.10+commit.fc410830">
                                  v0.8.10+commit.fc410830
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.11.8+commit.f095442d"
                                >
                                  v0.8.10-nightly.2021.11.8+commit.f095442d
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.11.5+commit.2f720f22"
                                >
                                  v0.8.10-nightly.2021.11.5+commit.2f720f22
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.11.4+commit.dd0ff194"
                                >
                                  v0.8.10-nightly.2021.11.4+commit.dd0ff194
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.11.3+commit.4a49e6e4"
                                >
                                  v0.8.10-nightly.2021.11.3+commit.4a49e6e4
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.11.2+commit.a7b13782"
                                >
                                  v0.8.10-nightly.2021.11.2+commit.a7b13782
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.11.1+commit.5eb97fa6"
                                >
                                  v0.8.10-nightly.2021.11.1+commit.5eb97fa6
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.29+commit.408bd5fa"
                                >
                                  v0.8.10-nightly.2021.10.29+commit.408bd5fa
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.28+commit.558d9d45"
                                >
                                  v0.8.10-nightly.2021.10.28+commit.558d9d45
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.27+commit.cede3693"
                                >
                                  v0.8.10-nightly.2021.10.27+commit.cede3693
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.26+commit.453f404f"
                                >
                                  v0.8.10-nightly.2021.10.26+commit.453f404f
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.25+commit.e6e30f82"
                                >
                                  v0.8.10-nightly.2021.10.25+commit.e6e30f82
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.22+commit.3774955d"
                                >
                                  v0.8.10-nightly.2021.10.22+commit.3774955d
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.20+commit.ef21e43f"
                                >
                                  v0.8.10-nightly.2021.10.20+commit.ef21e43f
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.19+commit.863a0d3b"
                                >
                                  v0.8.10-nightly.2021.10.19+commit.863a0d3b
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.18+commit.6bca1549"
                                >
                                  v0.8.10-nightly.2021.10.18+commit.6bca1549
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.16+commit.fdf3b96e"
                                >
                                  v0.8.10-nightly.2021.10.16+commit.fdf3b96e
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.15+commit.7f0771f8"
                                >
                                  v0.8.10-nightly.2021.10.15+commit.7f0771f8
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.14+commit.1e630fc5"
                                >
                                  v0.8.10-nightly.2021.10.14+commit.1e630fc5
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.13+commit.1deda33e"
                                >
                                  v0.8.10-nightly.2021.10.13+commit.1deda33e
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.12+commit.a79120fe"
                                >
                                  v0.8.10-nightly.2021.10.12+commit.a79120fe
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.11+commit.b0a5b92f"
                                >
                                  v0.8.10-nightly.2021.10.11+commit.b0a5b92f
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.7+commit.b343e132"
                                >
                                  v0.8.10-nightly.2021.10.7+commit.b343e132
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.6+commit.0549c42c"
                                >
                                  v0.8.10-nightly.2021.10.6+commit.0549c42c
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.5+commit.9c6ca4f4"
                                >
                                  v0.8.10-nightly.2021.10.5+commit.9c6ca4f4
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.4+commit.9d6eaa7a"
                                >
                                  v0.8.10-nightly.2021.10.4+commit.9d6eaa7a
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.10.1+commit.d10e668f"
                                >
                                  v0.8.10-nightly.2021.10.1+commit.d10e668f
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.9.30+commit.0e7e936f"
                                >
                                  v0.8.10-nightly.2021.9.30+commit.0e7e936f
                                </option>
                                <option
                                  value="v0.8.10-nightly.2021.9.29+commit.7a9f4815"
                                >
                                  v0.8.10-nightly.2021.9.29+commit.7a9f4815
                                </option>
                                <option value="v0.8.9+commit.e5eed63a">
                                  v0.8.9+commit.e5eed63a
                                </option>
                                <option value="v0.8.8+commit.dddeac2f">
                                  v0.8.8+commit.dddeac2f
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.28+commit.89d959d7"
                                >
                                  v0.8.8-nightly.2021.9.28+commit.89d959d7
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.27+commit.c3ef27f3"
                                >
                                  v0.8.8-nightly.2021.9.27+commit.c3ef27f3
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.24+commit.3c8846e6"
                                >
                                  v0.8.8-nightly.2021.9.24+commit.3c8846e6
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.23+commit.55467c1c"
                                >
                                  v0.8.8-nightly.2021.9.23+commit.55467c1c
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.22+commit.72fc3449"
                                >
                                  v0.8.8-nightly.2021.9.22+commit.72fc3449
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.21+commit.fc954367"
                                >
                                  v0.8.8-nightly.2021.9.21+commit.fc954367
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.20+commit.2c3322cb"
                                >
                                  v0.8.8-nightly.2021.9.20+commit.2c3322cb
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.17+commit.d7ddfcc6"
                                >
                                  v0.8.8-nightly.2021.9.17+commit.d7ddfcc6
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.16+commit.7877758c"
                                >
                                  v0.8.8-nightly.2021.9.16+commit.7877758c
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.15+commit.c1070fab"
                                >
                                  v0.8.8-nightly.2021.9.15+commit.c1070fab
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.14+commit.0fa24c78"
                                >
                                  v0.8.8-nightly.2021.9.14+commit.0fa24c78
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.13+commit.49cde9d4"
                                >
                                  v0.8.8-nightly.2021.9.13+commit.49cde9d4
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.9+commit.dea1b9ec"
                                >
                                  v0.8.8-nightly.2021.9.9+commit.dea1b9ec
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.8+commit.dae6b53c"
                                >
                                  v0.8.8-nightly.2021.9.8+commit.dae6b53c
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.7+commit.6feed460"
                                >
                                  v0.8.8-nightly.2021.9.7+commit.6feed460
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.6+commit.11a85059"
                                >
                                  v0.8.8-nightly.2021.9.6+commit.11a85059
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.3+commit.8447b32d"
                                >
                                  v0.8.8-nightly.2021.9.3+commit.8447b32d
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.2+commit.7f137d35"
                                >
                                  v0.8.8-nightly.2021.9.2+commit.7f137d35
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.9.1+commit.70fe0c65"
                                >
                                  v0.8.8-nightly.2021.9.1+commit.70fe0c65
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.31+commit.1e334a89"
                                >
                                  v0.8.8-nightly.2021.8.31+commit.1e334a89
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.30+commit.78afd71a"
                                >
                                  v0.8.8-nightly.2021.8.30+commit.78afd71a
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.27+commit.a3d8da25"
                                >
                                  v0.8.8-nightly.2021.8.27+commit.a3d8da25
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.26+commit.7df33f0d"
                                >
                                  v0.8.8-nightly.2021.8.26+commit.7df33f0d
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.25+commit.208cf6a3"
                                >
                                  v0.8.8-nightly.2021.8.25+commit.208cf6a3
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.24+commit.7a0295ec"
                                >
                                  v0.8.8-nightly.2021.8.24+commit.7a0295ec
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.23+commit.a39eb7ae"
                                >
                                  v0.8.8-nightly.2021.8.23+commit.a39eb7ae
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.20+commit.6b7857d5"
                                >
                                  v0.8.8-nightly.2021.8.20+commit.6b7857d5
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.19+commit.26207968"
                                >
                                  v0.8.8-nightly.2021.8.19+commit.26207968
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.18+commit.cef0f1b9"
                                >
                                  v0.8.8-nightly.2021.8.18+commit.cef0f1b9
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.17+commit.729db521"
                                >
                                  v0.8.8-nightly.2021.8.17+commit.729db521
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.16+commit.97b4ff15"
                                >
                                  v0.8.8-nightly.2021.8.16+commit.97b4ff15
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.12+commit.4fdf7db0"
                                >
                                  v0.8.8-nightly.2021.8.12+commit.4fdf7db0
                                </option>
                                <option
                                  value="v0.8.8-nightly.2021.8.11+commit.cc4e24c2"
                                >
                                  v0.8.8-nightly.2021.8.11+commit.cc4e24c2
                                </option>
                                <option value="v0.8.7+commit.e28d00a7">
                                  v0.8.7+commit.e28d00a7
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.10+commit.13b26949"
                                >
                                  v0.8.7-nightly.2021.8.10+commit.13b26949
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.9+commit.74c804d8"
                                >
                                  v0.8.7-nightly.2021.8.9+commit.74c804d8
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.6+commit.ce0e0c48"
                                >
                                  v0.8.7-nightly.2021.8.6+commit.ce0e0c48
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.5+commit.a532df20"
                                >
                                  v0.8.7-nightly.2021.8.5+commit.a532df20
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.4+commit.2d5b9036"
                                >
                                  v0.8.7-nightly.2021.8.4+commit.2d5b9036
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.3+commit.ae519c12"
                                >
                                  v0.8.7-nightly.2021.8.3+commit.ae519c12
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.8.2+commit.e9cab0ff"
                                >
                                  v0.8.7-nightly.2021.8.2+commit.e9cab0ff
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.29+commit.5ff0811b"
                                >
                                  v0.8.7-nightly.2021.7.29+commit.5ff0811b
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.28+commit.1794e1c8"
                                >
                                  v0.8.7-nightly.2021.7.28+commit.1794e1c8
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.27+commit.c018cdf4"
                                >
                                  v0.8.7-nightly.2021.7.27+commit.c018cdf4
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.26+commit.f97fe813"
                                >
                                  v0.8.7-nightly.2021.7.26+commit.f97fe813
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.25+commit.a2ce4616"
                                >
                                  v0.8.7-nightly.2021.7.25+commit.a2ce4616
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.21+commit.6d6c9e6e"
                                >
                                  v0.8.7-nightly.2021.7.21+commit.6d6c9e6e
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.20+commit.d655a3c9"
                                >
                                  v0.8.7-nightly.2021.7.20+commit.d655a3c9
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.15+commit.3d26d47d"
                                >
                                  v0.8.7-nightly.2021.7.15+commit.3d26d47d
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.14+commit.90f77f8c"
                                >
                                  v0.8.7-nightly.2021.7.14+commit.90f77f8c
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.13+commit.57d32ca2"
                                >
                                  v0.8.7-nightly.2021.7.13+commit.57d32ca2
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.12+commit.ef6ad57c"
                                >
                                  v0.8.7-nightly.2021.7.12+commit.ef6ad57c
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.8+commit.c3fa520c"
                                >
                                  v0.8.7-nightly.2021.7.8+commit.c3fa520c
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.7+commit.46514ffa"
                                >
                                  v0.8.7-nightly.2021.7.7+commit.46514ffa
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.6+commit.69233c37"
                                >
                                  v0.8.7-nightly.2021.7.6+commit.69233c37
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.5+commit.19b217dc"
                                >
                                  v0.8.7-nightly.2021.7.5+commit.19b217dc
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.2+commit.f6cb933f"
                                >
                                  v0.8.7-nightly.2021.7.2+commit.f6cb933f
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.7.1+commit.98e1dee4"
                                >
                                  v0.8.7-nightly.2021.7.1+commit.98e1dee4
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.6.30+commit.8a6a330d"
                                >
                                  v0.8.7-nightly.2021.6.30+commit.8a6a330d
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.6.29+commit.eaac16c7"
                                >
                                  v0.8.7-nightly.2021.6.29+commit.eaac16c7
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.6.28+commit.d91dc995"
                                >
                                  v0.8.7-nightly.2021.6.28+commit.d91dc995
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.6.23+commit.cbf1c3ae"
                                >
                                  v0.8.7-nightly.2021.6.23+commit.cbf1c3ae
                                </option>
                                <option
                                  value="v0.8.7-nightly.2021.6.22+commit.9cf6021d"
                                >
                                  v0.8.7-nightly.2021.6.22+commit.9cf6021d
                                </option>
                                <option value="v0.8.6+commit.11564f7e">
                                  v0.8.6+commit.11564f7e
                                </option>
                                <option
                                  value="v0.8.6-nightly.2021.6.21+commit.a96114b3"
                                >
                                  v0.8.6-nightly.2021.6.21+commit.a96114b3
                                </option>
                                <option
                                  value="v0.8.6-nightly.2021.6.17+commit.11281586"
                                >
                                  v0.8.6-nightly.2021.6.17+commit.11281586
                                </option>
                                <option
                                  value="v0.8.6-nightly.2021.6.16+commit.61468301"
                                >
                                  v0.8.6-nightly.2021.6.16+commit.61468301
                                </option>
                                <option
                                  value="v0.8.6-nightly.2021.6.15+commit.e7bf1cc7"
                                >
                                  v0.8.6-nightly.2021.6.15+commit.e7bf1cc7
                                </option>
                                <option
                                  value="v0.8.6-nightly.2021.6.14+commit.b2ffa910"
                                >
                                  v0.8.6-nightly.2021.6.14+commit.b2ffa910
                                </option>
                                <option value="v0.8.5+commit.a4f2e591">
                                  v0.8.5+commit.a4f2e591
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.10+commit.a4f2e591"
                                >
                                  v0.8.5-nightly.2021.6.10+commit.a4f2e591
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.9+commit.98e7b61a"
                                >
                                  v0.8.5-nightly.2021.6.9+commit.98e7b61a
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.8+commit.e77e9e44"
                                >
                                  v0.8.5-nightly.2021.6.8+commit.e77e9e44
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.7+commit.7d8a4e63"
                                >
                                  v0.8.5-nightly.2021.6.7+commit.7d8a4e63
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.4+commit.1f8f1a3d"
                                >
                                  v0.8.5-nightly.2021.6.4+commit.1f8f1a3d
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.3+commit.1638b210"
                                >
                                  v0.8.5-nightly.2021.6.3+commit.1638b210
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.6.1+commit.4cbf9ff7"
                                >
                                  v0.8.5-nightly.2021.6.1+commit.4cbf9ff7
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.31+commit.7d1df951"
                                >
                                  v0.8.5-nightly.2021.5.31+commit.7d1df951
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.27+commit.2f0df8f0"
                                >
                                  v0.8.5-nightly.2021.5.27+commit.2f0df8f0
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.26+commit.a3634934"
                                >
                                  v0.8.5-nightly.2021.5.26+commit.a3634934
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.25+commit.6640fb8c"
                                >
                                  v0.8.5-nightly.2021.5.25+commit.6640fb8c
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.24+commit.c5031799"
                                >
                                  v0.8.5-nightly.2021.5.24+commit.c5031799
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.21+commit.29c8f282"
                                >
                                  v0.8.5-nightly.2021.5.21+commit.29c8f282
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.20+commit.13388e28"
                                >
                                  v0.8.5-nightly.2021.5.20+commit.13388e28
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.19+commit.d07c85db"
                                >
                                  v0.8.5-nightly.2021.5.19+commit.d07c85db
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.18+commit.dac24294"
                                >
                                  v0.8.5-nightly.2021.5.18+commit.dac24294
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.17+commit.21af5408"
                                >
                                  v0.8.5-nightly.2021.5.17+commit.21af5408
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.14+commit.f58d5873"
                                >
                                  v0.8.5-nightly.2021.5.14+commit.f58d5873
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.13+commit.324caef5"
                                >
                                  v0.8.5-nightly.2021.5.13+commit.324caef5
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.12+commit.98e2b4e5"
                                >
                                  v0.8.5-nightly.2021.5.12+commit.98e2b4e5
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.11+commit.eb991775"
                                >
                                  v0.8.5-nightly.2021.5.11+commit.eb991775
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.10+commit.643140e2"
                                >
                                  v0.8.5-nightly.2021.5.10+commit.643140e2
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.7+commit.5d070c5b"
                                >
                                  v0.8.5-nightly.2021.5.7+commit.5d070c5b
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.6+commit.518629a8"
                                >
                                  v0.8.5-nightly.2021.5.6+commit.518629a8
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.5+commit.4c7b61d8"
                                >
                                  v0.8.5-nightly.2021.5.5+commit.4c7b61d8
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.4+commit.1d1175c2"
                                >
                                  v0.8.5-nightly.2021.5.4+commit.1d1175c2
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.5.3+commit.fe4822a1"
                                >
                                  v0.8.5-nightly.2021.5.3+commit.fe4822a1
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.29+commit.f1d58c54"
                                >
                                  v0.8.5-nightly.2021.4.29+commit.f1d58c54
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.28+commit.850c25bf"
                                >
                                  v0.8.5-nightly.2021.4.28+commit.850c25bf
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.27+commit.c7944637"
                                >
                                  v0.8.5-nightly.2021.4.27+commit.c7944637
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.26+commit.2e99a56b"
                                >
                                  v0.8.5-nightly.2021.4.26+commit.2e99a56b
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.24+commit.eed0bf58"
                                >
                                  v0.8.5-nightly.2021.4.24+commit.eed0bf58
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.23+commit.173a5118"
                                >
                                  v0.8.5-nightly.2021.4.23+commit.173a5118
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.22+commit.f162c484"
                                >
                                  v0.8.5-nightly.2021.4.22+commit.f162c484
                                </option>
                                <option
                                  value="v0.8.5-nightly.2021.4.21+commit.85274304"
                                >
                                  v0.8.5-nightly.2021.4.21+commit.85274304
                                </option>
                                <option value="v0.8.4+commit.c7e474f2">
                                  v0.8.4+commit.c7e474f2
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.20+commit.cf7f814a"
                                >
                                  v0.8.4-nightly.2021.4.20+commit.cf7f814a
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.19+commit.159d6f9e"
                                >
                                  v0.8.4-nightly.2021.4.19+commit.159d6f9e
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.16+commit.f9b23ca8"
                                >
                                  v0.8.4-nightly.2021.4.16+commit.f9b23ca8
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.14+commit.69411436"
                                >
                                  v0.8.4-nightly.2021.4.14+commit.69411436
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.13+commit.f188f3d9"
                                >
                                  v0.8.4-nightly.2021.4.13+commit.f188f3d9
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.12+commit.0289994d"
                                >
                                  v0.8.4-nightly.2021.4.12+commit.0289994d
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.8+commit.124db22f"
                                >
                                  v0.8.4-nightly.2021.4.8+commit.124db22f
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.6+commit.a5cae64a"
                                >
                                  v0.8.4-nightly.2021.4.6+commit.a5cae64a
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.4.1+commit.5433a640"
                                >
                                  v0.8.4-nightly.2021.4.1+commit.5433a640
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.3.31+commit.b2555eac"
                                >
                                  v0.8.4-nightly.2021.3.31+commit.b2555eac
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.3.30+commit.851051c6"
                                >
                                  v0.8.4-nightly.2021.3.30+commit.851051c6
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.3.29+commit.2346ec1c"
                                >
                                  v0.8.4-nightly.2021.3.29+commit.2346ec1c
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.3.26+commit.c37bf893"
                                >
                                  v0.8.4-nightly.2021.3.26+commit.c37bf893
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.3.25+commit.d75a132f"
                                >
                                  v0.8.4-nightly.2021.3.25+commit.d75a132f
                                </option>
                                <option
                                  value="v0.8.4-nightly.2021.3.24+commit.6eac77ae"
                                >
                                  v0.8.4-nightly.2021.3.24+commit.6eac77ae
                                </option>
                                <option value="v0.8.3+commit.8d00100c">
                                  v0.8.3+commit.8d00100c
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.22+commit.54cea090"
                                >
                                  v0.8.3-nightly.2021.3.22+commit.54cea090
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.17+commit.e179d0aa"
                                >
                                  v0.8.3-nightly.2021.3.17+commit.e179d0aa
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.16+commit.35da404c"
                                >
                                  v0.8.3-nightly.2021.3.16+commit.35da404c
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.15+commit.ae1b321a"
                                >
                                  v0.8.3-nightly.2021.3.15+commit.ae1b321a
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.12+commit.ccd9de13"
                                >
                                  v0.8.3-nightly.2021.3.12+commit.ccd9de13
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.11+commit.0e22d0bd"
                                >
                                  v0.8.3-nightly.2021.3.11+commit.0e22d0bd
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.10+commit.23f03e1b"
                                >
                                  v0.8.3-nightly.2021.3.10+commit.23f03e1b
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.9+commit.ad5d34df"
                                >
                                  v0.8.3-nightly.2021.3.9+commit.ad5d34df
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.5+commit.093ea461"
                                >
                                  v0.8.3-nightly.2021.3.5+commit.093ea461
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.4+commit.08df163a"
                                >
                                  v0.8.3-nightly.2021.3.4+commit.08df163a
                                </option>
                                <option
                                  value="v0.8.3-nightly.2021.3.3+commit.be564773"
                                >
                                  v0.8.3-nightly.2021.3.3+commit.be564773
                                </option>
                                <option value="v0.8.2+commit.661d1103">
                                  v0.8.2+commit.661d1103
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.3.2+commit.661d1103"
                                >
                                  v0.8.2-nightly.2021.3.2+commit.661d1103
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.3.1+commit.ad48b713"
                                >
                                  v0.8.2-nightly.2021.3.1+commit.ad48b713
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.25+commit.44493ad4"
                                >
                                  v0.8.2-nightly.2021.2.25+commit.44493ad4
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.24+commit.eacf7c1c"
                                >
                                  v0.8.2-nightly.2021.2.24+commit.eacf7c1c
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.23+commit.1220d8df"
                                >
                                  v0.8.2-nightly.2021.2.23+commit.1220d8df
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.22+commit.e75e3fc2"
                                >
                                  v0.8.2-nightly.2021.2.22+commit.e75e3fc2
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.19+commit.6fd5ea01"
                                >
                                  v0.8.2-nightly.2021.2.19+commit.6fd5ea01
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.18+commit.5c6633f9"
                                >
                                  v0.8.2-nightly.2021.2.18+commit.5c6633f9
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.12+commit.b385b41f"
                                >
                                  v0.8.2-nightly.2021.2.12+commit.b385b41f
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.11+commit.003701f6"
                                >
                                  v0.8.2-nightly.2021.2.11+commit.003701f6
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.10+commit.215233d5"
                                >
                                  v0.8.2-nightly.2021.2.10+commit.215233d5
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.9+commit.9b20c984"
                                >
                                  v0.8.2-nightly.2021.2.9+commit.9b20c984
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.8+commit.ec62d123"
                                >
                                  v0.8.2-nightly.2021.2.8+commit.ec62d123
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.4+commit.2fb27884"
                                >
                                  v0.8.2-nightly.2021.2.4+commit.2fb27884
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.3+commit.1a949e53"
                                >
                                  v0.8.2-nightly.2021.2.3+commit.1a949e53
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.2+commit.358324ed"
                                >
                                  v0.8.2-nightly.2021.2.2+commit.358324ed
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.2.1+commit.dde6353c"
                                >
                                  v0.8.2-nightly.2021.2.1+commit.dde6353c
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.1.28+commit.70882cc4"
                                >
                                  v0.8.2-nightly.2021.1.28+commit.70882cc4
                                </option>
                                <option
                                  value="v0.8.2-nightly.2021.1.27+commit.49dbcba3"
                                >
                                  v0.8.2-nightly.2021.1.27+commit.49dbcba3
                                </option>
                                <option value="v0.8.1+commit.df193b15">
                                  v0.8.1+commit.df193b15
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.27+commit.34fa756f"
                                >
                                  v0.8.1-nightly.2021.1.27+commit.34fa756f
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.25+commit.ccdf57c9"
                                >
                                  v0.8.1-nightly.2021.1.25+commit.ccdf57c9
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.22+commit.8a844237"
                                >
                                  v0.8.1-nightly.2021.1.22+commit.8a844237
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.21+commit.3045770a"
                                >
                                  v0.8.1-nightly.2021.1.21+commit.3045770a
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.20+commit.a75b87c8"
                                >
                                  v0.8.1-nightly.2021.1.20+commit.a75b87c8
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.19+commit.1df28473"
                                >
                                  v0.8.1-nightly.2021.1.19+commit.1df28473
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.18+commit.957e9995"
                                >
                                  v0.8.1-nightly.2021.1.18+commit.957e9995
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.15+commit.055c4b4d"
                                >
                                  v0.8.1-nightly.2021.1.15+commit.055c4b4d
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.14+commit.eaf7d7da"
                                >
                                  v0.8.1-nightly.2021.1.14+commit.eaf7d7da
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.13+commit.50146114"
                                >
                                  v0.8.1-nightly.2021.1.13+commit.50146114
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.12+commit.e9dcd4f8"
                                >
                                  v0.8.1-nightly.2021.1.12+commit.e9dcd4f8
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.11+commit.67d21a87"
                                >
                                  v0.8.1-nightly.2021.1.11+commit.67d21a87
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.8+commit.f03245d4"
                                >
                                  v0.8.1-nightly.2021.1.8+commit.f03245d4
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.7+commit.d11cf15d"
                                >
                                  v0.8.1-nightly.2021.1.7+commit.d11cf15d
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.6+commit.5241b7b7"
                                >
                                  v0.8.1-nightly.2021.1.6+commit.5241b7b7
                                </option>
                                <option
                                  value="v0.8.1-nightly.2021.1.4+commit.fce6d999"
                                >
                                  v0.8.1-nightly.2021.1.4+commit.fce6d999
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.30+commit.0e32fa82"
                                >
                                  v0.8.1-nightly.2020.12.30+commit.0e32fa82
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.29+commit.86c30b4c"
                                >
                                  v0.8.1-nightly.2020.12.29+commit.86c30b4c
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.28+commit.8e9a5a02"
                                >
                                  v0.8.1-nightly.2020.12.28+commit.8e9a5a02
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.22+commit.e299d8ba"
                                >
                                  v0.8.1-nightly.2020.12.22+commit.e299d8ba
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.21+commit.b78443ac"
                                >
                                  v0.8.1-nightly.2020.12.21+commit.b78443ac
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.20+commit.67712d50"
                                >
                                  v0.8.1-nightly.2020.12.20+commit.67712d50
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.18+commit.158154ba"
                                >
                                  v0.8.1-nightly.2020.12.18+commit.158154ba
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.17+commit.8194cbb4"
                                >
                                  v0.8.1-nightly.2020.12.17+commit.8194cbb4
                                </option>
                                <option
                                  value="v0.8.1-nightly.2020.12.16+commit.2be078b4"
                                >
                                  v0.8.1-nightly.2020.12.16+commit.2be078b4
                                </option>
                                <option
                                  selected="selected"
                                  value="v0.8.0+commit.c7dfd78e"
                                >
                                  v0.8.0+commit.c7dfd78e
                                </option>
                                <option value="v0.7.6+commit.7338295f">
                                  v0.7.6+commit.7338295f
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.15+commit.17293858"
                                >
                                  v0.7.6-nightly.2020.12.15+commit.17293858
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.14+commit.d83ce0bc"
                                >
                                  v0.7.6-nightly.2020.12.14+commit.d83ce0bc
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.11+commit.db9aa36d"
                                >
                                  v0.7.6-nightly.2020.12.11+commit.db9aa36d
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.10+commit.9e4f3bad"
                                >
                                  v0.7.6-nightly.2020.12.10+commit.9e4f3bad
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.9+commit.7e930f7b"
                                >
                                  v0.7.6-nightly.2020.12.9+commit.7e930f7b
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.8+commit.0d7f9ae1"
                                >
                                  v0.7.6-nightly.2020.12.8+commit.0d7f9ae1
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.7+commit.b23d9230"
                                >
                                  v0.7.6-nightly.2020.12.7+commit.b23d9230
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.4+commit.3619a0a0"
                                >
                                  v0.7.6-nightly.2020.12.4+commit.3619a0a0
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.3+commit.a27d7707"
                                >
                                  v0.7.6-nightly.2020.12.3+commit.a27d7707
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.2+commit.3cd0b252"
                                >
                                  v0.7.6-nightly.2020.12.2+commit.3cd0b252
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.12.1+commit.e10712c1"
                                >
                                  v0.7.6-nightly.2020.12.1+commit.e10712c1
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.30+commit.91e67472"
                                >
                                  v0.7.6-nightly.2020.11.30+commit.91e67472
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.27+commit.887569ef"
                                >
                                  v0.7.6-nightly.2020.11.27+commit.887569ef
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.26+commit.e8843fe1"
                                >
                                  v0.7.6-nightly.2020.11.26+commit.e8843fe1
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.25+commit.7eb5fc31"
                                >
                                  v0.7.6-nightly.2020.11.25+commit.7eb5fc31
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.24+commit.ae34fba4"
                                >
                                  v0.7.6-nightly.2020.11.24+commit.ae34fba4
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.23+commit.61425e35"
                                >
                                  v0.7.6-nightly.2020.11.23+commit.61425e35
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.21+commit.8bf455bb"
                                >
                                  v0.7.6-nightly.2020.11.21+commit.8bf455bb
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.20+commit.3a3303f2"
                                >
                                  v0.7.6-nightly.2020.11.20+commit.3a3303f2
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.19+commit.8d315ee1"
                                >
                                  v0.7.6-nightly.2020.11.19+commit.8d315ee1
                                </option>
                                <option
                                  value="v0.7.6-nightly.2020.11.18+commit.bfe87378"
                                >
                                  v0.7.6-nightly.2020.11.18+commit.bfe87378
                                </option>
                                <option value="v0.7.5+commit.eb77ed08">
                                  v0.7.5+commit.eb77ed08
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.17+commit.e1292380"
                                >
                                  v0.7.5-nightly.2020.11.17+commit.e1292380
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.16+commit.a97521bf"
                                >
                                  v0.7.5-nightly.2020.11.16+commit.a97521bf
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.13+commit.f1846b57"
                                >
                                  v0.7.5-nightly.2020.11.13+commit.f1846b57
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.12+commit.c69c7f32"
                                >
                                  v0.7.5-nightly.2020.11.12+commit.c69c7f32
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.11+commit.44eb63fa"
                                >
                                  v0.7.5-nightly.2020.11.11+commit.44eb63fa
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.10+commit.d3a016b5"
                                >
                                  v0.7.5-nightly.2020.11.10+commit.d3a016b5
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.9+commit.41f50365"
                                >
                                  v0.7.5-nightly.2020.11.9+commit.41f50365
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.6+commit.6fa42b5e"
                                >
                                  v0.7.5-nightly.2020.11.6+commit.6fa42b5e
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.5+commit.f55f5c24"
                                >
                                  v0.7.5-nightly.2020.11.5+commit.f55f5c24
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.4+commit.5b412544"
                                >
                                  v0.7.5-nightly.2020.11.4+commit.5b412544
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.3+commit.a8045ba5"
                                >
                                  v0.7.5-nightly.2020.11.3+commit.a8045ba5
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.11.2+commit.c83d8fae"
                                >
                                  v0.7.5-nightly.2020.11.2+commit.c83d8fae
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.29+commit.be02db49"
                                >
                                  v0.7.5-nightly.2020.10.29+commit.be02db49
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.28+commit.f42280f5"
                                >
                                  v0.7.5-nightly.2020.10.28+commit.f42280f5
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.27+commit.f1ed5100"
                                >
                                  v0.7.5-nightly.2020.10.27+commit.f1ed5100
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.26+commit.96c188be"
                                >
                                  v0.7.5-nightly.2020.10.26+commit.96c188be
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.23+commit.08a27b9c"
                                >
                                  v0.7.5-nightly.2020.10.23+commit.08a27b9c
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.22+commit.95c521a3"
                                >
                                  v0.7.5-nightly.2020.10.22+commit.95c521a3
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.21+commit.38d58a45"
                                >
                                  v0.7.5-nightly.2020.10.21+commit.38d58a45
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.20+commit.06394672"
                                >
                                  v0.7.5-nightly.2020.10.20+commit.06394672
                                </option>
                                <option
                                  value="v0.7.5-nightly.2020.10.19+commit.58579332"
                                >
                                  v0.7.5-nightly.2020.10.19+commit.58579332
                                </option>
                                <option value="v0.7.4+commit.3f05b770">
                                  v0.7.4+commit.3f05b770
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.18+commit.6aae7cae"
                                >
                                  v0.7.4-nightly.2020.10.18+commit.6aae7cae
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.16+commit.eedd12ad"
                                >
                                  v0.7.4-nightly.2020.10.16+commit.eedd12ad
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.15+commit.9aafb62e"
                                >
                                  v0.7.4-nightly.2020.10.15+commit.9aafb62e
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.14+commit.36a36caf"
                                >
                                  v0.7.4-nightly.2020.10.14+commit.36a36caf
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.13+commit.8d241fec"
                                >
                                  v0.7.4-nightly.2020.10.13+commit.8d241fec
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.12+commit.abfa136a"
                                >
                                  v0.7.4-nightly.2020.10.12+commit.abfa136a
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.9+commit.d9215cf9"
                                >
                                  v0.7.4-nightly.2020.10.9+commit.d9215cf9
                                </option>
                                <option
                                  value="v0.7.4-nightly.2020.10.8+commit.3739b03a"
                                >
                                  v0.7.4-nightly.2020.10.8+commit.3739b03a
                                </option>
                                <option value="v0.7.3+commit.9bfce1f6">
                                  v0.7.3+commit.9bfce1f6
                                </option>
                                <option
                                  value="v0.7.3-nightly.2020.10.6+commit.25d40805"
                                >
                                  v0.7.3-nightly.2020.10.6+commit.25d40805
                                </option>
                                <option
                                  value="v0.7.3-nightly.2020.10.2+commit.756e21a8"
                                >
                                  v0.7.3-nightly.2020.10.2+commit.756e21a8
                                </option>
                                <option
                                  value="v0.7.3-nightly.2020.9.30+commit.3af21c92"
                                >
                                  v0.7.3-nightly.2020.9.30+commit.3af21c92
                                </option>
                                <option
                                  value="v0.7.3-nightly.2020.9.29+commit.343c13f9"
                                >
                                  v0.7.3-nightly.2020.9.29+commit.343c13f9
                                </option>
                                <option
                                  value="v0.7.3-nightly.2020.9.28+commit.dd5b0a71"
                                >
                                  v0.7.3-nightly.2020.9.28+commit.dd5b0a71
                                </option>
                                <option value="v0.7.2+commit.51b20bc0">
                                  v0.7.2+commit.51b20bc0
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.25+commit.b34465c5"
                                >
                                  v0.7.2-nightly.2020.9.25+commit.b34465c5
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.24+commit.5711d664"
                                >
                                  v0.7.2-nightly.2020.9.24+commit.5711d664
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.23+commit.35a7d5d3"
                                >
                                  v0.7.2-nightly.2020.9.23+commit.35a7d5d3
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.22+commit.700cc4c9"
                                >
                                  v0.7.2-nightly.2020.9.22+commit.700cc4c9
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.21+commit.d80a81b0"
                                >
                                  v0.7.2-nightly.2020.9.21+commit.d80a81b0
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.17+commit.b571fd05"
                                >
                                  v0.7.2-nightly.2020.9.17+commit.b571fd05
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.16+commit.90506528"
                                >
                                  v0.7.2-nightly.2020.9.16+commit.90506528
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.15+commit.3399570d"
                                >
                                  v0.7.2-nightly.2020.9.15+commit.3399570d
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.12+commit.38175150"
                                >
                                  v0.7.2-nightly.2020.9.12+commit.38175150
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.11+commit.31b5102a"
                                >
                                  v0.7.2-nightly.2020.9.11+commit.31b5102a
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.10+commit.0db79dbc"
                                >
                                  v0.7.2-nightly.2020.9.10+commit.0db79dbc
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.9+commit.95a284e5"
                                >
                                  v0.7.2-nightly.2020.9.9+commit.95a284e5
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.8+commit.20233240"
                                >
                                  v0.7.2-nightly.2020.9.8+commit.20233240
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.7+commit.38e6f272"
                                >
                                  v0.7.2-nightly.2020.9.7+commit.38e6f272
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.3+commit.f9649660"
                                >
                                  v0.7.2-nightly.2020.9.3+commit.f9649660
                                </option>
                                <option
                                  value="v0.7.2-nightly.2020.9.2+commit.cde65224"
                                >
                                  v0.7.2-nightly.2020.9.2+commit.cde65224
                                </option>
                                <option value="v0.7.1+commit.f4a555be">
                                  v0.7.1+commit.f4a555be
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.9.1+commit.0d83977d"
                                >
                                  v0.7.1-nightly.2020.9.1+commit.0d83977d
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.31+commit.34543e5e"
                                >
                                  v0.7.1-nightly.2020.8.31+commit.34543e5e
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.28+commit.98cc1d99"
                                >
                                  v0.7.1-nightly.2020.8.28+commit.98cc1d99
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.27+commit.e872b1b5"
                                >
                                  v0.7.1-nightly.2020.8.27+commit.e872b1b5
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.26+commit.fdc4142b"
                                >
                                  v0.7.1-nightly.2020.8.26+commit.fdc4142b
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.25+commit.29b6c172"
                                >
                                  v0.7.1-nightly.2020.8.25+commit.29b6c172
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.24+commit.21489d81"
                                >
                                  v0.7.1-nightly.2020.8.24+commit.21489d81
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.22+commit.bff0f9bd"
                                >
                                  v0.7.1-nightly.2020.8.22+commit.bff0f9bd
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.21+commit.4dd25f73"
                                >
                                  v0.7.1-nightly.2020.8.21+commit.4dd25f73
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.20+commit.4a720a65"
                                >
                                  v0.7.1-nightly.2020.8.20+commit.4a720a65
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.19+commit.9e488f12"
                                >
                                  v0.7.1-nightly.2020.8.19+commit.9e488f12
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.18+commit.3c27d36e"
                                >
                                  v0.7.1-nightly.2020.8.18+commit.3c27d36e
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.17+commit.660ef792"
                                >
                                  v0.7.1-nightly.2020.8.17+commit.660ef792
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.13+commit.b1fb9da6"
                                >
                                  v0.7.1-nightly.2020.8.13+commit.b1fb9da6
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.12+commit.acdaff63"
                                >
                                  v0.7.1-nightly.2020.8.12+commit.acdaff63
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.11+commit.e68d16d8"
                                >
                                  v0.7.1-nightly.2020.8.11+commit.e68d16d8
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.10+commit.05901f5b"
                                >
                                  v0.7.1-nightly.2020.8.10+commit.05901f5b
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.6+commit.241a564f"
                                >
                                  v0.7.1-nightly.2020.8.6+commit.241a564f
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.5+commit.3a409c39"
                                >
                                  v0.7.1-nightly.2020.8.5+commit.3a409c39
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.4+commit.b8fd409f"
                                >
                                  v0.7.1-nightly.2020.8.4+commit.b8fd409f
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.8.3+commit.d31f05fc"
                                >
                                  v0.7.1-nightly.2020.8.3+commit.d31f05fc
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.7.31+commit.08791ab0"
                                >
                                  v0.7.1-nightly.2020.7.31+commit.08791ab0
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.7.29+commit.f2fa5b5f"
                                >
                                  v0.7.1-nightly.2020.7.29+commit.f2fa5b5f
                                </option>
                                <option
                                  value="v0.7.1-nightly.2020.7.28+commit.cd2ce283"
                                >
                                  v0.7.1-nightly.2020.7.28+commit.cd2ce283
                                </option>
                                <option value="v0.7.0+commit.9e61f92b">
                                  v0.7.0+commit.9e61f92b
                                </option>
                                <option
                                  value="v0.7.0-nightly.2020.7.27+commit.4e4b3ee6"
                                >
                                  v0.7.0-nightly.2020.7.27+commit.4e4b3ee6
                                </option>
                                <option
                                  value="v0.7.0-nightly.2020.7.23+commit.7ad27188"
                                >
                                  v0.7.0-nightly.2020.7.23+commit.7ad27188
                                </option>
                                <option value="v0.6.12+commit.27d51765">
                                  v0.6.12+commit.27d51765
                                </option>
                                <option value="v0.6.11+commit.5ef660b1">
                                  v0.6.11+commit.5ef660b1
                                </option>
                                <option
                                  value="v0.6.11-nightly.2020.6.25+commit.48dd3634"
                                >
                                  v0.6.11-nightly.2020.6.25+commit.48dd3634
                                </option>
                                <option value="v0.6.10+commit.00c0fcaf">
                                  v0.6.10+commit.00c0fcaf
                                </option>
                                <option
                                  value="v0.6.10-nightly.2020.6.10+commit.0a5d9927"
                                >
                                  v0.6.10-nightly.2020.6.10+commit.0a5d9927
                                </option>
                                <option
                                  value="v0.6.10-nightly.2020.6.9+commit.1e8e0ebd"
                                >
                                  v0.6.10-nightly.2020.6.9+commit.1e8e0ebd
                                </option>
                                <option
                                  value="v0.6.10-nightly.2020.6.8+commit.3d241eed"
                                >
                                  v0.6.10-nightly.2020.6.8+commit.3d241eed
                                </option>
                                <option
                                  value="v0.6.10-nightly.2020.6.5+commit.d4552678"
                                >
                                  v0.6.10-nightly.2020.6.5+commit.d4552678
                                </option>
                                <option
                                  value="v0.6.10-nightly.2020.6.4+commit.0ec96337"
                                >
                                  v0.6.10-nightly.2020.6.4+commit.0ec96337
                                </option>
                                <option value="v0.6.9+commit.3e3065ac">
                                  v0.6.9+commit.3e3065ac
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.6.4+commit.70e62524"
                                >
                                  v0.6.9-nightly.2020.6.4+commit.70e62524
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.6.3+commit.de5e2835"
                                >
                                  v0.6.9-nightly.2020.6.3+commit.de5e2835
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.6.2+commit.22f7a9f0"
                                >
                                  v0.6.9-nightly.2020.6.2+commit.22f7a9f0
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.5.29+commit.b01a1a36"
                                >
                                  v0.6.9-nightly.2020.5.29+commit.b01a1a36
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.5.28+commit.ee8307ce"
                                >
                                  v0.6.9-nightly.2020.5.28+commit.ee8307ce
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.5.27+commit.57ac8628"
                                >
                                  v0.6.9-nightly.2020.5.27+commit.57ac8628
                                </option>
                                <option
                                  value="v0.6.9-nightly.2020.5.14+commit.33d8d838"
                                >
                                  v0.6.9-nightly.2020.5.14+commit.33d8d838
                                </option>
                                <option value="v0.6.8+commit.0bbfe453">
                                  v0.6.8+commit.0bbfe453
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.14+commit.a6d0067b"
                                >
                                  v0.6.8-nightly.2020.5.14+commit.a6d0067b
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.13+commit.aca70049"
                                >
                                  v0.6.8-nightly.2020.5.13+commit.aca70049
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.12+commit.b014b89e"
                                >
                                  v0.6.8-nightly.2020.5.12+commit.b014b89e
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.11+commit.39249bc6"
                                >
                                  v0.6.8-nightly.2020.5.11+commit.39249bc6
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.8+commit.4e58c672"
                                >
                                  v0.6.8-nightly.2020.5.8+commit.4e58c672
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.7+commit.741c41a1"
                                >
                                  v0.6.8-nightly.2020.5.7+commit.741c41a1
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.6+commit.3a93080c"
                                >
                                  v0.6.8-nightly.2020.5.6+commit.3a93080c
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.5+commit.1de73a16"
                                >
                                  v0.6.8-nightly.2020.5.5+commit.1de73a16
                                </option>
                                <option
                                  value="v0.6.8-nightly.2020.5.4+commit.1bb07e26"
                                >
                                  v0.6.8-nightly.2020.5.4+commit.1bb07e26
                                </option>
                                <option value="v0.6.7+commit.b8d736ae">
                                  v0.6.7+commit.b8d736ae
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.5.4+commit.94f7ffcf"
                                >
                                  v0.6.7-nightly.2020.5.4+commit.94f7ffcf
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.5.1+commit.5163c09e"
                                >
                                  v0.6.7-nightly.2020.5.1+commit.5163c09e
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.29+commit.602b29cb"
                                >
                                  v0.6.7-nightly.2020.4.29+commit.602b29cb
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.28+commit.75a25d53"
                                >
                                  v0.6.7-nightly.2020.4.28+commit.75a25d53
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.27+commit.61b1369f"
                                >
                                  v0.6.7-nightly.2020.4.27+commit.61b1369f
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.25+commit.ed6c6b31"
                                >
                                  v0.6.7-nightly.2020.4.25+commit.ed6c6b31
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.24+commit.2b39f3b9"
                                >
                                  v0.6.7-nightly.2020.4.24+commit.2b39f3b9
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.23+commit.aaa434da"
                                >
                                  v0.6.7-nightly.2020.4.23+commit.aaa434da
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.22+commit.d0fcd468"
                                >
                                  v0.6.7-nightly.2020.4.22+commit.d0fcd468
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.20+commit.7eff836a"
                                >
                                  v0.6.7-nightly.2020.4.20+commit.7eff836a
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.17+commit.ccc06c49"
                                >
                                  v0.6.7-nightly.2020.4.17+commit.ccc06c49
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.16+commit.0f7a5e80"
                                >
                                  v0.6.7-nightly.2020.4.16+commit.0f7a5e80
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.15+commit.cbd90f8d"
                                >
                                  v0.6.7-nightly.2020.4.15+commit.cbd90f8d
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.14+commit.accd8d76"
                                >
                                  v0.6.7-nightly.2020.4.14+commit.accd8d76
                                </option>
                                <option
                                  value="v0.6.7-nightly.2020.4.9+commit.f8aaa83e"
                                >
                                  v0.6.7-nightly.2020.4.9+commit.f8aaa83e
                                </option>
                                <option value="v0.6.6+commit.6c089d02">
                                  v0.6.6+commit.6c089d02
                                </option>
                                <option
                                  value="v0.6.6-nightly.2020.4.9+commit.605e176f"
                                >
                                  v0.6.6-nightly.2020.4.9+commit.605e176f
                                </option>
                                <option
                                  value="v0.6.6-nightly.2020.4.8+commit.9fab9df1"
                                >
                                  v0.6.6-nightly.2020.4.8+commit.9fab9df1
                                </option>
                                <option
                                  value="v0.6.6-nightly.2020.4.7+commit.582c7545"
                                >
                                  v0.6.6-nightly.2020.4.7+commit.582c7545
                                </option>
                                <option
                                  value="v0.6.6-nightly.2020.4.6+commit.e349f4b7"
                                >
                                  v0.6.6-nightly.2020.4.6+commit.e349f4b7
                                </option>
                                <option value="v0.6.5+commit.f956cc89">
                                  v0.6.5+commit.f956cc89
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.4.6+commit.8451639f"
                                >
                                  v0.6.5-nightly.2020.4.6+commit.8451639f
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.4.3+commit.00acaadd"
                                >
                                  v0.6.5-nightly.2020.4.3+commit.00acaadd
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.4.2+commit.c8f0629e"
                                >
                                  v0.6.5-nightly.2020.4.2+commit.c8f0629e
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.4.1+commit.c11d5b8d"
                                >
                                  v0.6.5-nightly.2020.4.1+commit.c11d5b8d
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.31+commit.b83d82ab"
                                >
                                  v0.6.5-nightly.2020.3.31+commit.b83d82ab
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.30+commit.469316f8"
                                >
                                  v0.6.5-nightly.2020.3.30+commit.469316f8
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.26+commit.994591b8"
                                >
                                  v0.6.5-nightly.2020.3.26+commit.994591b8
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.25+commit.18971389"
                                >
                                  v0.6.5-nightly.2020.3.25+commit.18971389
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.24+commit.d584b2d1"
                                >
                                  v0.6.5-nightly.2020.3.24+commit.d584b2d1
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.23+commit.848f405f"
                                >
                                  v0.6.5-nightly.2020.3.23+commit.848f405f
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.19+commit.8834b1ac"
                                >
                                  v0.6.5-nightly.2020.3.19+commit.8834b1ac
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.18+commit.cfd315e1"
                                >
                                  v0.6.5-nightly.2020.3.18+commit.cfd315e1
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.17+commit.435c9dae"
                                >
                                  v0.6.5-nightly.2020.3.17+commit.435c9dae
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.16+commit.e21567c1"
                                >
                                  v0.6.5-nightly.2020.3.16+commit.e21567c1
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.13+commit.362c2175"
                                >
                                  v0.6.5-nightly.2020.3.13+commit.362c2175
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.12+commit.bdd8045d"
                                >
                                  v0.6.5-nightly.2020.3.12+commit.bdd8045d
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.11+commit.1167af1d"
                                >
                                  v0.6.5-nightly.2020.3.11+commit.1167af1d
                                </option>
                                <option
                                  value="v0.6.5-nightly.2020.3.10+commit.59071f60"
                                >
                                  v0.6.5-nightly.2020.3.10+commit.59071f60
                                </option>
                                <option value="v0.6.4+commit.1dca32f3">
                                  v0.6.4+commit.1dca32f3
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.3.10+commit.683ebc8e"
                                >
                                  v0.6.4-nightly.2020.3.10+commit.683ebc8e
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.3.9+commit.dbe2a5f4"
                                >
                                  v0.6.4-nightly.2020.3.9+commit.dbe2a5f4
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.3.8+commit.a328e940"
                                >
                                  v0.6.4-nightly.2020.3.8+commit.a328e940
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.3.6+commit.78ce4b96"
                                >
                                  v0.6.4-nightly.2020.3.6+commit.78ce4b96
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.3.4+commit.27a4670a"
                                >
                                  v0.6.4-nightly.2020.3.4+commit.27a4670a
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.3.3+commit.20679d63"
                                >
                                  v0.6.4-nightly.2020.3.3+commit.20679d63
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.27+commit.b65a165d"
                                >
                                  v0.6.4-nightly.2020.2.27+commit.b65a165d
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.26+commit.6930e0c2"
                                >
                                  v0.6.4-nightly.2020.2.26+commit.6930e0c2
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.25+commit.af81d4b6"
                                >
                                  v0.6.4-nightly.2020.2.25+commit.af81d4b6
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.24+commit.aa6a2b47"
                                >
                                  v0.6.4-nightly.2020.2.24+commit.aa6a2b47
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.20+commit.525fe384"
                                >
                                  v0.6.4-nightly.2020.2.20+commit.525fe384
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.19+commit.8f2c5fc0"
                                >
                                  v0.6.4-nightly.2020.2.19+commit.8f2c5fc0
                                </option>
                                <option
                                  value="v0.6.4-nightly.2020.2.18+commit.ba9f740a"
                                >
                                  v0.6.4-nightly.2020.2.18+commit.ba9f740a
                                </option>
                                <option value="v0.6.3+commit.8dda9521">
                                  v0.6.3+commit.8dda9521
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.18+commit.64f9dc35"
                                >
                                  v0.6.3-nightly.2020.2.18+commit.64f9dc35
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.17+commit.50421e8b"
                                >
                                  v0.6.3-nightly.2020.2.17+commit.50421e8b
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.14+commit.96709b32"
                                >
                                  v0.6.3-nightly.2020.2.14+commit.96709b32
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.13+commit.7af581df"
                                >
                                  v0.6.3-nightly.2020.2.13+commit.7af581df
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.12+commit.0e100e7e"
                                >
                                  v0.6.3-nightly.2020.2.12+commit.0e100e7e
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.11+commit.5214cb0e"
                                >
                                  v0.6.3-nightly.2020.2.11+commit.5214cb0e
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.10+commit.64bb0d55"
                                >
                                  v0.6.3-nightly.2020.2.10+commit.64bb0d55
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.7+commit.462cd432"
                                >
                                  v0.6.3-nightly.2020.2.7+commit.462cd432
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.6+commit.93191ceb"
                                >
                                  v0.6.3-nightly.2020.2.6+commit.93191ceb
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.5+commit.913d5f32"
                                >
                                  v0.6.3-nightly.2020.2.5+commit.913d5f32
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.4+commit.836938c1"
                                >
                                  v0.6.3-nightly.2020.2.4+commit.836938c1
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.2.3+commit.93a41f7a"
                                >
                                  v0.6.3-nightly.2020.2.3+commit.93a41f7a
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.1.31+commit.b6190e06"
                                >
                                  v0.6.3-nightly.2020.1.31+commit.b6190e06
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.1.30+commit.ad98bf0f"
                                >
                                  v0.6.3-nightly.2020.1.30+commit.ad98bf0f
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.1.29+commit.01eb9a5b"
                                >
                                  v0.6.3-nightly.2020.1.29+commit.01eb9a5b
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.1.28+commit.2d3bd91d"
                                >
                                  v0.6.3-nightly.2020.1.28+commit.2d3bd91d
                                </option>
                                <option
                                  value="v0.6.3-nightly.2020.1.27+commit.8809d4bb"
                                >
                                  v0.6.3-nightly.2020.1.27+commit.8809d4bb
                                </option>
                                <option value="v0.6.2+commit.bacdbe57">
                                  v0.6.2+commit.bacdbe57
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.27+commit.1bdb409b"
                                >
                                  v0.6.2-nightly.2020.1.27+commit.1bdb409b
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.23+commit.3add37a2"
                                >
                                  v0.6.2-nightly.2020.1.23+commit.3add37a2
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.22+commit.641bb815"
                                >
                                  v0.6.2-nightly.2020.1.22+commit.641bb815
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.20+commit.470c19eb"
                                >
                                  v0.6.2-nightly.2020.1.20+commit.470c19eb
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.17+commit.92908f52"
                                >
                                  v0.6.2-nightly.2020.1.17+commit.92908f52
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.16+commit.3d4a2219"
                                >
                                  v0.6.2-nightly.2020.1.16+commit.3d4a2219
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.15+commit.9d9a7ebe"
                                >
                                  v0.6.2-nightly.2020.1.15+commit.9d9a7ebe
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.14+commit.6dbadf69"
                                >
                                  v0.6.2-nightly.2020.1.14+commit.6dbadf69
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.13+commit.408458b7"
                                >
                                  v0.6.2-nightly.2020.1.13+commit.408458b7
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.10+commit.d577a768"
                                >
                                  v0.6.2-nightly.2020.1.10+commit.d577a768
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.9+commit.17158995"
                                >
                                  v0.6.2-nightly.2020.1.9+commit.17158995
                                </option>
                                <option
                                  value="v0.6.2-nightly.2020.1.8+commit.12b52ae6"
                                >
                                  v0.6.2-nightly.2020.1.8+commit.12b52ae6
                                </option>
                                <option value="v0.6.1+commit.e6f7d5a4">
                                  v0.6.1+commit.e6f7d5a4
                                </option>
                                <option
                                  value="v0.6.1-nightly.2020.1.7+commit.8385256b"
                                >
                                  v0.6.1-nightly.2020.1.7+commit.8385256b
                                </option>
                                <option
                                  value="v0.6.1-nightly.2020.1.6+commit.20cf9d9f"
                                >
                                  v0.6.1-nightly.2020.1.6+commit.20cf9d9f
                                </option>
                                <option
                                  value="v0.6.1-nightly.2020.1.3+commit.943af71d"
                                >
                                  v0.6.1-nightly.2020.1.3+commit.943af71d
                                </option>
                                <option
                                  value="v0.6.1-nightly.2020.1.2+commit.d082b9b8"
                                >
                                  v0.6.1-nightly.2020.1.2+commit.d082b9b8
                                </option>
                                <option
                                  value="v0.6.1-nightly.2019.12.20+commit.ece6463f"
                                >
                                  v0.6.1-nightly.2019.12.20+commit.ece6463f
                                </option>
                                <option
                                  value="v0.6.1-nightly.2019.12.19+commit.d420fe37"
                                >
                                  v0.6.1-nightly.2019.12.19+commit.d420fe37
                                </option>
                                <option
                                  value="v0.6.1-nightly.2019.12.18+commit.9a1cc027"
                                >
                                  v0.6.1-nightly.2019.12.18+commit.9a1cc027
                                </option>
                                <option value="v0.6.0+commit.26b70077">
                                  v0.6.0+commit.26b70077
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.17+commit.d13438ee"
                                >
                                  v0.6.0-nightly.2019.12.17+commit.d13438ee
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.16+commit.7390b5b5"
                                >
                                  v0.6.0-nightly.2019.12.16+commit.7390b5b5
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.14+commit.1c01c69e"
                                >
                                  v0.6.0-nightly.2019.12.14+commit.1c01c69e
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.13+commit.9ddd5042"
                                >
                                  v0.6.0-nightly.2019.12.13+commit.9ddd5042
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.12+commit.104a8c59"
                                >
                                  v0.6.0-nightly.2019.12.12+commit.104a8c59
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.11+commit.7247e72d"
                                >
                                  v0.6.0-nightly.2019.12.11+commit.7247e72d
                                </option>
                                <option
                                  value="v0.6.0-nightly.2019.12.10+commit.7244aa01"
                                >
                                  v0.6.0-nightly.2019.12.10+commit.7244aa01
                                </option>
                                <option value="v0.5.17+commit.d19bba13">
                                  v0.5.17+commit.d19bba13
                                </option>
                                <option value="v0.5.16+commit.9c3226ce">
                                  v0.5.16+commit.9c3226ce
                                </option>
                                <option value="v0.5.15+commit.6a57276f">
                                  v0.5.15+commit.6a57276f
                                </option>
                                <option value="v0.5.14+commit.01f1aaa4">
                                  v0.5.14+commit.01f1aaa4
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.12.10+commit.45aa7a88"
                                >
                                  v0.5.14-nightly.2019.12.10+commit.45aa7a88
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.12.9+commit.d6667560"
                                >
                                  v0.5.14-nightly.2019.12.9+commit.d6667560
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.12.5+commit.d2e3933d"
                                >
                                  v0.5.14-nightly.2019.12.5+commit.d2e3933d
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.12.4+commit.2a1b6f55"
                                >
                                  v0.5.14-nightly.2019.12.4+commit.2a1b6f55
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.30+commit.4775af73"
                                >
                                  v0.5.14-nightly.2019.11.30+commit.4775af73
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.29+commit.7b038dbd"
                                >
                                  v0.5.14-nightly.2019.11.29+commit.7b038dbd
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.28+commit.40d9744b"
                                >
                                  v0.5.14-nightly.2019.11.28+commit.40d9744b
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.27+commit.87943bf4"
                                >
                                  v0.5.14-nightly.2019.11.27+commit.87943bf4
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.26+commit.200a92b4"
                                >
                                  v0.5.14-nightly.2019.11.26+commit.200a92b4
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.25+commit.c4622774"
                                >
                                  v0.5.14-nightly.2019.11.25+commit.c4622774
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.21+commit.9eac460c"
                                >
                                  v0.5.14-nightly.2019.11.21+commit.9eac460c
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.20+commit.7535039f"
                                >
                                  v0.5.14-nightly.2019.11.20+commit.7535039f
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.19+commit.e383b2bb"
                                >
                                  v0.5.14-nightly.2019.11.19+commit.e383b2bb
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.18+commit.79af19db"
                                >
                                  v0.5.14-nightly.2019.11.18+commit.79af19db
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.15+commit.6a993152"
                                >
                                  v0.5.14-nightly.2019.11.15+commit.6a993152
                                </option>
                                <option
                                  value="v0.5.14-nightly.2019.11.14+commit.3e04fd6e"
                                >
                                  v0.5.14-nightly.2019.11.14+commit.3e04fd6e
                                </option>
                                <option value="v0.5.13+commit.5b0b510c">
                                  v0.5.13+commit.5b0b510c
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.14+commit.d1c6ab8a"
                                >
                                  v0.5.13-nightly.2019.11.14+commit.d1c6ab8a
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.13+commit.6bef3071"
                                >
                                  v0.5.13-nightly.2019.11.13+commit.6bef3071
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.12+commit.52a9de83"
                                >
                                  v0.5.13-nightly.2019.11.12+commit.52a9de83
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.11+commit.7c7cca5f"
                                >
                                  v0.5.13-nightly.2019.11.11+commit.7c7cca5f
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.10+commit.a5f0422d"
                                >
                                  v0.5.13-nightly.2019.11.10+commit.a5f0422d
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.8+commit.78be9385"
                                >
                                  v0.5.13-nightly.2019.11.8+commit.78be9385
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.7+commit.37c6ab4c"
                                >
                                  v0.5.13-nightly.2019.11.7+commit.37c6ab4c
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.6+commit.56a3abcd"
                                >
                                  v0.5.13-nightly.2019.11.6+commit.56a3abcd
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.5+commit.9bec5334"
                                >
                                  v0.5.13-nightly.2019.11.5+commit.9bec5334
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.4+commit.26c6a1fc"
                                >
                                  v0.5.13-nightly.2019.11.4+commit.26c6a1fc
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.11.1+commit.73954f16"
                                >
                                  v0.5.13-nightly.2019.11.1+commit.73954f16
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.31+commit.d932f2d0"
                                >
                                  v0.5.13-nightly.2019.10.31+commit.d932f2d0
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.29+commit.5d906cd5"
                                >
                                  v0.5.13-nightly.2019.10.29+commit.5d906cd5
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.28+commit.9eb08c0c"
                                >
                                  v0.5.13-nightly.2019.10.28+commit.9eb08c0c
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.25+commit.302a51a5"
                                >
                                  v0.5.13-nightly.2019.10.25+commit.302a51a5
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.24+commit.15e39f7d"
                                >
                                  v0.5.13-nightly.2019.10.24+commit.15e39f7d
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.23+commit.e56d1aa5"
                                >
                                  v0.5.13-nightly.2019.10.23+commit.e56d1aa5
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.22+commit.eca2b9bd"
                                >
                                  v0.5.13-nightly.2019.10.22+commit.eca2b9bd
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.18+commit.d5b2f347"
                                >
                                  v0.5.13-nightly.2019.10.18+commit.d5b2f347
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.17+commit.5ea1d90f"
                                >
                                  v0.5.13-nightly.2019.10.17+commit.5ea1d90f
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.16+commit.9ec8bcda"
                                >
                                  v0.5.13-nightly.2019.10.16+commit.9ec8bcda
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.15+commit.83bb1515"
                                >
                                  v0.5.13-nightly.2019.10.15+commit.83bb1515
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.4+commit.6cbcc379"
                                >
                                  v0.5.13-nightly.2019.10.4+commit.6cbcc379
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.2+commit.2d150b65"
                                >
                                  v0.5.13-nightly.2019.10.2+commit.2d150b65
                                </option>
                                <option
                                  value="v0.5.13-nightly.2019.10.1+commit.74d2b228"
                                >
                                  v0.5.13-nightly.2019.10.1+commit.74d2b228
                                </option>
                                <option value="v0.5.12+commit.7709ece9">
                                  v0.5.12+commit.7709ece9
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.10.1+commit.cbdc3bc1"
                                >
                                  v0.5.12-nightly.2019.10.1+commit.cbdc3bc1
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.30+commit.88476475"
                                >
                                  v0.5.12-nightly.2019.9.30+commit.88476475
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.24+commit.973e4ca9"
                                >
                                  v0.5.12-nightly.2019.9.24+commit.973e4ca9
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.23+commit.c4208a6a"
                                >
                                  v0.5.12-nightly.2019.9.23+commit.c4208a6a
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.19+commit.0478eb1e"
                                >
                                  v0.5.12-nightly.2019.9.19+commit.0478eb1e
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.17+commit.58f0f9db"
                                >
                                  v0.5.12-nightly.2019.9.17+commit.58f0f9db
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.16+commit.34a84f3a"
                                >
                                  v0.5.12-nightly.2019.9.16+commit.34a84f3a
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.13+commit.5d58c43a"
                                >
                                  v0.5.12-nightly.2019.9.13+commit.5d58c43a
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.12+commit.b747c267"
                                >
                                  v0.5.12-nightly.2019.9.12+commit.b747c267
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.11+commit.5063e537"
                                >
                                  v0.5.12-nightly.2019.9.11+commit.5063e537
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.10+commit.4452a9b6"
                                >
                                  v0.5.12-nightly.2019.9.10+commit.4452a9b6
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.9+commit.f5e976ce"
                                >
                                  v0.5.12-nightly.2019.9.9+commit.f5e976ce
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.6+commit.7e80fceb"
                                >
                                  v0.5.12-nightly.2019.9.6+commit.7e80fceb
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.5+commit.96980d0b"
                                >
                                  v0.5.12-nightly.2019.9.5+commit.96980d0b
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.4+commit.c5fbf23f"
                                >
                                  v0.5.12-nightly.2019.9.4+commit.c5fbf23f
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.3+commit.d1831b15"
                                >
                                  v0.5.12-nightly.2019.9.3+commit.d1831b15
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.9.2+commit.3c963eb0"
                                >
                                  v0.5.12-nightly.2019.9.2+commit.3c963eb0
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.29+commit.459aed90"
                                >
                                  v0.5.12-nightly.2019.8.29+commit.459aed90
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.28+commit.e74b63b6"
                                >
                                  v0.5.12-nightly.2019.8.28+commit.e74b63b6
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.26+commit.e1bb4b9f"
                                >
                                  v0.5.12-nightly.2019.8.26+commit.e1bb4b9f
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.24+commit.bb104546"
                                >
                                  v0.5.12-nightly.2019.8.24+commit.bb104546
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.23+commit.b5048bd6"
                                >
                                  v0.5.12-nightly.2019.8.23+commit.b5048bd6
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.19+commit.a39d26f3"
                                >
                                  v0.5.12-nightly.2019.8.19+commit.a39d26f3
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.16+commit.058bbd39"
                                >
                                  v0.5.12-nightly.2019.8.16+commit.058bbd39
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.15+commit.2508cbc1"
                                >
                                  v0.5.12-nightly.2019.8.15+commit.2508cbc1
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.14+commit.fb8137df"
                                >
                                  v0.5.12-nightly.2019.8.14+commit.fb8137df
                                </option>
                                <option
                                  value="v0.5.12-nightly.2019.8.13+commit.a6cbc3b8"
                                >
                                  v0.5.12-nightly.2019.8.13+commit.a6cbc3b8
                                </option>
                                <option value="v0.5.11+commit.22be8592">
                                  v0.5.11+commit.22be8592
                                </option>
                                <option value="v0.5.11+commit.c082d0b4">
                                  v0.5.11+commit.c082d0b4
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.12+commit.b285e086"
                                >
                                  v0.5.11-nightly.2019.8.12+commit.b285e086
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.10+commit.f5f2bbb2"
                                >
                                  v0.5.11-nightly.2019.8.10+commit.f5f2bbb2
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.9+commit.682a3ece"
                                >
                                  v0.5.11-nightly.2019.8.9+commit.682a3ece
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.8+commit.16efcfdb"
                                >
                                  v0.5.11-nightly.2019.8.8+commit.16efcfdb
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.7+commit.6166dc8e"
                                >
                                  v0.5.11-nightly.2019.8.7+commit.6166dc8e
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.6+commit.cd563e52"
                                >
                                  v0.5.11-nightly.2019.8.6+commit.cd563e52
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.5+commit.29d47d5c"
                                >
                                  v0.5.11-nightly.2019.8.5+commit.29d47d5c
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.2+commit.967ee944"
                                >
                                  v0.5.11-nightly.2019.8.2+commit.967ee944
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.8.1+commit.aa87a607"
                                >
                                  v0.5.11-nightly.2019.8.1+commit.aa87a607
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.31+commit.32e6e356"
                                >
                                  v0.5.11-nightly.2019.7.31+commit.32e6e356
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.30+commit.092e62f1"
                                >
                                  v0.5.11-nightly.2019.7.30+commit.092e62f1
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.29+commit.2fdc07c5"
                                >
                                  v0.5.11-nightly.2019.7.29+commit.2fdc07c5
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.25+commit.4f7fec69"
                                >
                                  v0.5.11-nightly.2019.7.25+commit.4f7fec69
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.23+commit.14699340"
                                >
                                  v0.5.11-nightly.2019.7.23+commit.14699340
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.22+commit.535553b5"
                                >
                                  v0.5.11-nightly.2019.7.22+commit.535553b5
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.19+commit.508cf66d"
                                >
                                  v0.5.11-nightly.2019.7.19+commit.508cf66d
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.18+commit.1d673a3b"
                                >
                                  v0.5.11-nightly.2019.7.18+commit.1d673a3b
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.17+commit.4fa78004"
                                >
                                  v0.5.11-nightly.2019.7.17+commit.4fa78004
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.16+commit.a5a7983a"
                                >
                                  v0.5.11-nightly.2019.7.16+commit.a5a7983a
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.11+commit.88477bdb"
                                >
                                  v0.5.11-nightly.2019.7.11+commit.88477bdb
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.10+commit.ba922e76"
                                >
                                  v0.5.11-nightly.2019.7.10+commit.ba922e76
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.9+commit.8d006d20"
                                >
                                  v0.5.11-nightly.2019.7.9+commit.8d006d20
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.8+commit.25928767"
                                >
                                  v0.5.11-nightly.2019.7.8+commit.25928767
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.4+commit.3b2ebba4"
                                >
                                  v0.5.11-nightly.2019.7.4+commit.3b2ebba4
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.3+commit.c3c8bc09"
                                >
                                  v0.5.11-nightly.2019.7.3+commit.c3c8bc09
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.2+commit.06d01d15"
                                >
                                  v0.5.11-nightly.2019.7.2+commit.06d01d15
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.7.1+commit.b8dbf7d2"
                                >
                                  v0.5.11-nightly.2019.7.1+commit.b8dbf7d2
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.6.27+commit.3597de35"
                                >
                                  v0.5.11-nightly.2019.6.27+commit.3597de35
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.6.26+commit.b4a0a793"
                                >
                                  v0.5.11-nightly.2019.6.26+commit.b4a0a793
                                </option>
                                <option
                                  value="v0.5.11-nightly.2019.6.25+commit.1cc84753"
                                >
                                  v0.5.11-nightly.2019.6.25+commit.1cc84753
                                </option>
                                <option value="v0.5.10+commit.5a6ea5b1">
                                  v0.5.10+commit.5a6ea5b1
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.25+commit.92529068"
                                >
                                  v0.5.10-nightly.2019.6.25+commit.92529068
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.24+commit.eb5b8298"
                                >
                                  v0.5.10-nightly.2019.6.24+commit.eb5b8298
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.20+commit.096e3fcd"
                                >
                                  v0.5.10-nightly.2019.6.20+commit.096e3fcd
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.19+commit.53f26d97"
                                >
                                  v0.5.10-nightly.2019.6.19+commit.53f26d97
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.18+commit.b6695071"
                                >
                                  v0.5.10-nightly.2019.6.18+commit.b6695071
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.17+commit.9c5dc63e"
                                >
                                  v0.5.10-nightly.2019.6.17+commit.9c5dc63e
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.14+commit.4aa0c9e0"
                                >
                                  v0.5.10-nightly.2019.6.14+commit.4aa0c9e0
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.13+commit.62bd7032"
                                >
                                  v0.5.10-nightly.2019.6.13+commit.62bd7032
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.12+commit.502d22a2"
                                >
                                  v0.5.10-nightly.2019.6.12+commit.502d22a2
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.11+commit.bd1f65d6"
                                >
                                  v0.5.10-nightly.2019.6.11+commit.bd1f65d6
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.7+commit.dc085bb8"
                                >
                                  v0.5.10-nightly.2019.6.7+commit.dc085bb8
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.6+commit.fc35c139"
                                >
                                  v0.5.10-nightly.2019.6.6+commit.fc35c139
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.5+commit.3a331639"
                                >
                                  v0.5.10-nightly.2019.6.5+commit.3a331639
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.6.4+commit.95e6b2e4"
                                >
                                  v0.5.10-nightly.2019.6.4+commit.95e6b2e4
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.5.30+commit.dd04a35c"
                                >
                                  v0.5.10-nightly.2019.5.30+commit.dd04a35c
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.5.29+commit.c9e2d388"
                                >
                                  v0.5.10-nightly.2019.5.29+commit.c9e2d388
                                </option>
                                <option
                                  value="v0.5.10-nightly.2019.5.28+commit.ff8898b8"
                                >
                                  v0.5.10-nightly.2019.5.28+commit.ff8898b8
                                </option>
                                <option value="v0.5.9+commit.c68bc34e">
                                  v0.5.9+commit.c68bc34e
                                </option>
                                <option value="v0.5.9+commit.e560f70d">
                                  v0.5.9+commit.e560f70d
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.28+commit.01b6b680"
                                >
                                  v0.5.9-nightly.2019.5.28+commit.01b6b680
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.27+commit.c14279fc"
                                >
                                  v0.5.9-nightly.2019.5.27+commit.c14279fc
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.24+commit.2a2cea08"
                                >
                                  v0.5.9-nightly.2019.5.24+commit.2a2cea08
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.23+commit.7cf51876"
                                >
                                  v0.5.9-nightly.2019.5.23+commit.7cf51876
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.22+commit.f06582f9"
                                >
                                  v0.5.9-nightly.2019.5.22+commit.f06582f9
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.21+commit.0e132d07"
                                >
                                  v0.5.9-nightly.2019.5.21+commit.0e132d07
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.20+commit.0731abd3"
                                >
                                  v0.5.9-nightly.2019.5.20+commit.0731abd3
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.17+commit.88e9fbe6"
                                >
                                  v0.5.9-nightly.2019.5.17+commit.88e9fbe6
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.16+commit.46d6f395"
                                >
                                  v0.5.9-nightly.2019.5.16+commit.46d6f395
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.15+commit.a10501bb"
                                >
                                  v0.5.9-nightly.2019.5.15+commit.a10501bb
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.14+commit.563aec1d"
                                >
                                  v0.5.9-nightly.2019.5.14+commit.563aec1d
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.13+commit.a28b6224"
                                >
                                  v0.5.9-nightly.2019.5.13+commit.a28b6224
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.10+commit.661b08e1"
                                >
                                  v0.5.9-nightly.2019.5.10+commit.661b08e1
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.9+commit.8f2c8daf"
                                >
                                  v0.5.9-nightly.2019.5.9+commit.8f2c8daf
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.8+commit.97f16421"
                                >
                                  v0.5.9-nightly.2019.5.8+commit.97f16421
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.7+commit.a21f8a0b"
                                >
                                  v0.5.9-nightly.2019.5.7+commit.a21f8a0b
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.6+commit.dee1c110"
                                >
                                  v0.5.9-nightly.2019.5.6+commit.dee1c110
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.5.2+commit.90f2fe6f"
                                >
                                  v0.5.9-nightly.2019.5.2+commit.90f2fe6f
                                </option>
                                <option
                                  value="v0.5.9-nightly.2019.4.30+commit.b6bcd8a1"
                                >
                                  v0.5.9-nightly.2019.4.30+commit.b6bcd8a1
                                </option>
                                <option value="v0.5.8+commit.23d335f2">
                                  v0.5.8+commit.23d335f2
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.30+commit.0dc461b9"
                                >
                                  v0.5.8-nightly.2019.4.30+commit.0dc461b9
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.29+commit.578d6180"
                                >
                                  v0.5.8-nightly.2019.4.29+commit.578d6180
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.25+commit.eea425a3"
                                >
                                  v0.5.8-nightly.2019.4.25+commit.eea425a3
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.24+commit.f124bace"
                                >
                                  v0.5.8-nightly.2019.4.24+commit.f124bace
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.23+commit.13518820"
                                >
                                  v0.5.8-nightly.2019.4.23+commit.13518820
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.18+commit.fce19bde"
                                >
                                  v0.5.8-nightly.2019.4.18+commit.fce19bde
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.17+commit.1feefa1c"
                                >
                                  v0.5.8-nightly.2019.4.17+commit.1feefa1c
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.16+commit.a61931c5"
                                >
                                  v0.5.8-nightly.2019.4.16+commit.a61931c5
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.15+commit.e4e786a9"
                                >
                                  v0.5.8-nightly.2019.4.15+commit.e4e786a9
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.14+commit.6c68904f"
                                >
                                  v0.5.8-nightly.2019.4.14+commit.6c68904f
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.12+commit.31abeb99"
                                >
                                  v0.5.8-nightly.2019.4.12+commit.31abeb99
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.11+commit.e97d4b4a"
                                >
                                  v0.5.8-nightly.2019.4.11+commit.e97d4b4a
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.10+commit.9eaaf42c"
                                >
                                  v0.5.8-nightly.2019.4.10+commit.9eaaf42c
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.5+commit.9ef84df4"
                                >
                                  v0.5.8-nightly.2019.4.5+commit.9ef84df4
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.4+commit.ee2f5662"
                                >
                                  v0.5.8-nightly.2019.4.4+commit.ee2f5662
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.3+commit.1b7878cf"
                                >
                                  v0.5.8-nightly.2019.4.3+commit.1b7878cf
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.2+commit.7b0f7eb1"
                                >
                                  v0.5.8-nightly.2019.4.2+commit.7b0f7eb1
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.4.1+commit.a3a60b8e"
                                >
                                  v0.5.8-nightly.2019.4.1+commit.a3a60b8e
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.3.29+commit.91a54f9b"
                                >
                                  v0.5.8-nightly.2019.3.29+commit.91a54f9b
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.3.28+commit.2bbc41ad"
                                >
                                  v0.5.8-nightly.2019.3.28+commit.2bbc41ad
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.3.27+commit.97818f65"
                                >
                                  v0.5.8-nightly.2019.3.27+commit.97818f65
                                </option>
                                <option
                                  value="v0.5.8-nightly.2019.3.26+commit.b85fc1a6"
                                >
                                  v0.5.8-nightly.2019.3.26+commit.b85fc1a6
                                </option>
                                <option value="v0.5.7+commit.6da8b019">
                                  v0.5.7+commit.6da8b019
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.26+commit.d079cdbf"
                                >
                                  v0.5.7-nightly.2019.3.26+commit.d079cdbf
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.25+commit.99ed3a64"
                                >
                                  v0.5.7-nightly.2019.3.25+commit.99ed3a64
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.22+commit.0af47da1"
                                >
                                  v0.5.7-nightly.2019.3.22+commit.0af47da1
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.21+commit.ebb8c175"
                                >
                                  v0.5.7-nightly.2019.3.21+commit.ebb8c175
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.20+commit.5245a66d"
                                >
                                  v0.5.7-nightly.2019.3.20+commit.5245a66d
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.19+commit.c7824932"
                                >
                                  v0.5.7-nightly.2019.3.19+commit.c7824932
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.18+commit.5b5c9aa2"
                                >
                                  v0.5.7-nightly.2019.3.18+commit.5b5c9aa2
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.14+commit.d1d6d59c"
                                >
                                  v0.5.7-nightly.2019.3.14+commit.d1d6d59c
                                </option>
                                <option
                                  value="v0.5.7-nightly.2019.3.13+commit.2da906d9"
                                >
                                  v0.5.7-nightly.2019.3.13+commit.2da906d9
                                </option>
                                <option value="v0.5.6+commit.b259423e">
                                  v0.5.6+commit.b259423e
                                </option>
                                <option
                                  value="v0.5.6-nightly.2019.3.13+commit.9ccd5dfe"
                                >
                                  v0.5.6-nightly.2019.3.13+commit.9ccd5dfe
                                </option>
                                <option
                                  value="v0.5.6-nightly.2019.3.12+commit.2f37cd09"
                                >
                                  v0.5.6-nightly.2019.3.12+commit.2f37cd09
                                </option>
                                <option
                                  value="v0.5.6-nightly.2019.3.11+commit.189983a1"
                                >
                                  v0.5.6-nightly.2019.3.11+commit.189983a1
                                </option>
                                <option value="v0.5.5+commit.47a71e8f">
                                  v0.5.5+commit.47a71e8f
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.3.5+commit.c283f6d8"
                                >
                                  v0.5.5-nightly.2019.3.5+commit.c283f6d8
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.3.4+commit.5490a5cd"
                                >
                                  v0.5.5-nightly.2019.3.4+commit.5490a5cd
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.28+commit.e9543d83"
                                >
                                  v0.5.5-nightly.2019.2.28+commit.e9543d83
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.27+commit.a0dcb36f"
                                >
                                  v0.5.5-nightly.2019.2.27+commit.a0dcb36f
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.26+commit.472a6445"
                                >
                                  v0.5.5-nightly.2019.2.26+commit.472a6445
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.25+commit.52ee955f"
                                >
                                  v0.5.5-nightly.2019.2.25+commit.52ee955f
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.21+commit.e7a8fed0"
                                >
                                  v0.5.5-nightly.2019.2.21+commit.e7a8fed0
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.20+commit.c8fb2c1b"
                                >
                                  v0.5.5-nightly.2019.2.20+commit.c8fb2c1b
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.19+commit.d9e4a10d"
                                >
                                  v0.5.5-nightly.2019.2.19+commit.d9e4a10d
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.18+commit.db7b38e3"
                                >
                                  v0.5.5-nightly.2019.2.18+commit.db7b38e3
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.16+commit.2f0926c3"
                                >
                                  v0.5.5-nightly.2019.2.16+commit.2f0926c3
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.15+commit.04081303"
                                >
                                  v0.5.5-nightly.2019.2.15+commit.04081303
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.14+commit.33318249"
                                >
                                  v0.5.5-nightly.2019.2.14+commit.33318249
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.13+commit.b1a5ffb9"
                                >
                                  v0.5.5-nightly.2019.2.13+commit.b1a5ffb9
                                </option>
                                <option
                                  value="v0.5.5-nightly.2019.2.12+commit.828255fa"
                                >
                                  v0.5.5-nightly.2019.2.12+commit.828255fa
                                </option>
                                <option value="v0.5.4+commit.9549d8ff">
                                  v0.5.4+commit.9549d8ff
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.2.12+commit.f0f34984"
                                >
                                  v0.5.4-nightly.2019.2.12+commit.f0f34984
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.2.11+commit.49cd55d3"
                                >
                                  v0.5.4-nightly.2019.2.11+commit.49cd55d3
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.2.7+commit.caecdfab"
                                >
                                  v0.5.4-nightly.2019.2.7+commit.caecdfab
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.2.6+commit.e5bf1f1d"
                                >
                                  v0.5.4-nightly.2019.2.6+commit.e5bf1f1d
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.2.5+commit.f3c9b41f"
                                >
                                  v0.5.4-nightly.2019.2.5+commit.f3c9b41f
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.2.4+commit.82b69963"
                                >
                                  v0.5.4-nightly.2019.2.4+commit.82b69963
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.31+commit.ddab3f06"
                                >
                                  v0.5.4-nightly.2019.1.31+commit.ddab3f06
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.30+commit.bf3968d6"
                                >
                                  v0.5.4-nightly.2019.1.30+commit.bf3968d6
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.29+commit.ebf503a6"
                                >
                                  v0.5.4-nightly.2019.1.29+commit.ebf503a6
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.28+commit.e6d102f2"
                                >
                                  v0.5.4-nightly.2019.1.28+commit.e6d102f2
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.26+commit.0ef45b28"
                                >
                                  v0.5.4-nightly.2019.1.26+commit.0ef45b28
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.24+commit.2e7274b4"
                                >
                                  v0.5.4-nightly.2019.1.24+commit.2e7274b4
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.23+commit.ea292393"
                                >
                                  v0.5.4-nightly.2019.1.23+commit.ea292393
                                </option>
                                <option
                                  value="v0.5.4-nightly.2019.1.22+commit.26c06550"
                                >
                                  v0.5.4-nightly.2019.1.22+commit.26c06550
                                </option>
                                <option value="v0.5.3+commit.10d17f24">
                                  v0.5.3+commit.10d17f24
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.22+commit.d87d9a26"
                                >
                                  v0.5.3-nightly.2019.1.22+commit.d87d9a26
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.21+commit.606c2b99"
                                >
                                  v0.5.3-nightly.2019.1.21+commit.606c2b99
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.19+commit.d3270bc3"
                                >
                                  v0.5.3-nightly.2019.1.19+commit.d3270bc3
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.18+commit.7b759866"
                                >
                                  v0.5.3-nightly.2019.1.18+commit.7b759866
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.17+commit.49f74a7b"
                                >
                                  v0.5.3-nightly.2019.1.17+commit.49f74a7b
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.16+commit.82453a76"
                                >
                                  v0.5.3-nightly.2019.1.16+commit.82453a76
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.15+commit.6146c59a"
                                >
                                  v0.5.3-nightly.2019.1.15+commit.6146c59a
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.14+commit.051df319"
                                >
                                  v0.5.3-nightly.2019.1.14+commit.051df319
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.11+commit.94688d2f"
                                >
                                  v0.5.3-nightly.2019.1.11+commit.94688d2f
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.10+commit.31033fb4"
                                >
                                  v0.5.3-nightly.2019.1.10+commit.31033fb4
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.9+commit.63319cfd"
                                >
                                  v0.5.3-nightly.2019.1.9+commit.63319cfd
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.8+commit.a0ca746c"
                                >
                                  v0.5.3-nightly.2019.1.8+commit.a0ca746c
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.7+commit.f3799034"
                                >
                                  v0.5.3-nightly.2019.1.7+commit.f3799034
                                </option>
                                <option
                                  value="v0.5.3-nightly.2019.1.3+commit.d597b1db"
                                >
                                  v0.5.3-nightly.2019.1.3+commit.d597b1db
                                </option>
                                <option
                                  value="v0.5.3-nightly.2018.12.20+commit.245ec29c"
                                >
                                  v0.5.3-nightly.2018.12.20+commit.245ec29c
                                </option>
                                <option value="v0.5.2+commit.1df8f40c">
                                  v0.5.2+commit.1df8f40c
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.19+commit.88750920"
                                >
                                  v0.5.2-nightly.2018.12.19+commit.88750920
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.18+commit.4b43aeca"
                                >
                                  v0.5.2-nightly.2018.12.18+commit.4b43aeca
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.17+commit.12874029"
                                >
                                  v0.5.2-nightly.2018.12.17+commit.12874029
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.13+commit.b3e2ba15"
                                >
                                  v0.5.2-nightly.2018.12.13+commit.b3e2ba15
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.12+commit.85291bcb"
                                >
                                  v0.5.2-nightly.2018.12.12+commit.85291bcb
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.11+commit.599760b6"
                                >
                                  v0.5.2-nightly.2018.12.11+commit.599760b6
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.10+commit.6240d9e7"
                                >
                                  v0.5.2-nightly.2018.12.10+commit.6240d9e7
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.7+commit.52ff3c94"
                                >
                                  v0.5.2-nightly.2018.12.7+commit.52ff3c94
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.6+commit.5a08ae5e"
                                >
                                  v0.5.2-nightly.2018.12.6+commit.5a08ae5e
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.5+commit.6efe2a52"
                                >
                                  v0.5.2-nightly.2018.12.5+commit.6efe2a52
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.4+commit.e49f37be"
                                >
                                  v0.5.2-nightly.2018.12.4+commit.e49f37be
                                </option>
                                <option
                                  value="v0.5.2-nightly.2018.12.3+commit.e6a01d26"
                                >
                                  v0.5.2-nightly.2018.12.3+commit.e6a01d26
                                </option>
                                <option value="v0.5.1+commit.c8a2cb62">
                                  v0.5.1+commit.c8a2cb62
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.12.3+commit.a73df9bc"
                                >
                                  v0.5.1-nightly.2018.12.3+commit.a73df9bc
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.30+commit.a7ca4991"
                                >
                                  v0.5.1-nightly.2018.11.30+commit.a7ca4991
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.29+commit.f6d01323"
                                >
                                  v0.5.1-nightly.2018.11.29+commit.f6d01323
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.28+commit.7cbf0468"
                                >
                                  v0.5.1-nightly.2018.11.28+commit.7cbf0468
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.27+commit.bc7cb301"
                                >
                                  v0.5.1-nightly.2018.11.27+commit.bc7cb301
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.26+commit.f9378967"
                                >
                                  v0.5.1-nightly.2018.11.26+commit.f9378967
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.25+commit.1e03c160"
                                >
                                  v0.5.1-nightly.2018.11.25+commit.1e03c160
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.23+commit.616ef8bc"
                                >
                                  v0.5.1-nightly.2018.11.23+commit.616ef8bc
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.22+commit.dc748bc7"
                                >
                                  v0.5.1-nightly.2018.11.22+commit.dc748bc7
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.21+commit.2c6e1888"
                                >
                                  v0.5.1-nightly.2018.11.21+commit.2c6e1888
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.19+commit.d3f66ca0"
                                >
                                  v0.5.1-nightly.2018.11.19+commit.d3f66ca0
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.17+commit.5be45e73"
                                >
                                  v0.5.1-nightly.2018.11.17+commit.5be45e73
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.15+commit.9db76403"
                                >
                                  v0.5.1-nightly.2018.11.15+commit.9db76403
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.14+commit.10d99fc3"
                                >
                                  v0.5.1-nightly.2018.11.14+commit.10d99fc3
                                </option>
                                <option
                                  value="v0.5.1-nightly.2018.11.13+commit.74ede87a"
                                >
                                  v0.5.1-nightly.2018.11.13+commit.74ede87a
                                </option>
                                <option value="v0.5.0+commit.1d4f565a">
                                  v0.5.0+commit.1d4f565a
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.13+commit.ac980fb8"
                                >
                                  v0.5.0-nightly.2018.11.13+commit.ac980fb8
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.12+commit.09f8ff27"
                                >
                                  v0.5.0-nightly.2018.11.12+commit.09f8ff27
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.11+commit.405565db"
                                >
                                  v0.5.0-nightly.2018.11.11+commit.405565db
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.9+commit.9709dfe0"
                                >
                                  v0.5.0-nightly.2018.11.9+commit.9709dfe0
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.8+commit.cc2de07b"
                                >
                                  v0.5.0-nightly.2018.11.8+commit.cc2de07b
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.7+commit.a459b8c8"
                                >
                                  v0.5.0-nightly.2018.11.7+commit.a459b8c8
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.5+commit.88aee34c"
                                >
                                  v0.5.0-nightly.2018.11.5+commit.88aee34c
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.11.4+commit.e4da724f"
                                >
                                  v0.5.0-nightly.2018.11.4+commit.e4da724f
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.30+commit.cbbbc0d5"
                                >
                                  v0.5.0-nightly.2018.10.30+commit.cbbbc0d5
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.29+commit.0b4f6ab7"
                                >
                                  v0.5.0-nightly.2018.10.29+commit.0b4f6ab7
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.28+commit.c338b422"
                                >
                                  v0.5.0-nightly.2018.10.28+commit.c338b422
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.26+commit.c8400353"
                                >
                                  v0.5.0-nightly.2018.10.26+commit.c8400353
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.25+commit.f714b0dd"
                                >
                                  v0.5.0-nightly.2018.10.25+commit.f714b0dd
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.24+commit.01566c2e"
                                >
                                  v0.5.0-nightly.2018.10.24+commit.01566c2e
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.23+commit.f5f977ea"
                                >
                                  v0.5.0-nightly.2018.10.23+commit.f5f977ea
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.22+commit.a2f5087d"
                                >
                                  v0.5.0-nightly.2018.10.22+commit.a2f5087d
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.19+commit.c13b5280"
                                >
                                  v0.5.0-nightly.2018.10.19+commit.c13b5280
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.18+commit.99dc869e"
                                >
                                  v0.5.0-nightly.2018.10.18+commit.99dc869e
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.17+commit.ba158882"
                                >
                                  v0.5.0-nightly.2018.10.17+commit.ba158882
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.16+commit.b723893a"
                                >
                                  v0.5.0-nightly.2018.10.16+commit.b723893a
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.15+commit.b965fd6e"
                                >
                                  v0.5.0-nightly.2018.10.15+commit.b965fd6e
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.12+commit.1d312c8e"
                                >
                                  v0.5.0-nightly.2018.10.12+commit.1d312c8e
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.11+commit.6b5d041e"
                                >
                                  v0.5.0-nightly.2018.10.11+commit.6b5d041e
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.10+commit.06200b4b"
                                >
                                  v0.5.0-nightly.2018.10.10+commit.06200b4b
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.9+commit.4ab2e03b"
                                >
                                  v0.5.0-nightly.2018.10.9+commit.4ab2e03b
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.8+commit.7d2dc143"
                                >
                                  v0.5.0-nightly.2018.10.8+commit.7d2dc143
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.6+commit.363b527b"
                                >
                                  v0.5.0-nightly.2018.10.6+commit.363b527b
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.5+commit.44c1293a"
                                >
                                  v0.5.0-nightly.2018.10.5+commit.44c1293a
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.4+commit.68dfe8b6"
                                >
                                  v0.5.0-nightly.2018.10.4+commit.68dfe8b6
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.3+commit.b8b31eb3"
                                >
                                  v0.5.0-nightly.2018.10.3+commit.b8b31eb3
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.2+commit.b77b79c4"
                                >
                                  v0.5.0-nightly.2018.10.2+commit.b77b79c4
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.10.1+commit.80012e69"
                                >
                                  v0.5.0-nightly.2018.10.1+commit.80012e69
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.9.30+commit.8ef47cb6"
                                >
                                  v0.5.0-nightly.2018.9.30+commit.8ef47cb6
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.9.27+commit.963ae540"
                                >
                                  v0.5.0-nightly.2018.9.27+commit.963ae540
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.9.26+commit.d72498b3"
                                >
                                  v0.5.0-nightly.2018.9.26+commit.d72498b3
                                </option>
                                <option
                                  value="v0.5.0-nightly.2018.9.25+commit.608f36d7"
                                >
                                  v0.5.0-nightly.2018.9.25+commit.608f36d7
                                </option>
                                <option value="v0.4.26+commit.4563c3fc">
                                  v0.4.26+commit.4563c3fc
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.25+commit.1b8334e5"
                                >
                                  v0.4.26-nightly.2018.9.25+commit.1b8334e5
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.24+commit.dce1ed5a"
                                >
                                  v0.4.26-nightly.2018.9.24+commit.dce1ed5a
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.21+commit.8f96fe69"
                                >
                                  v0.4.26-nightly.2018.9.21+commit.8f96fe69
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.20+commit.2150aea3"
                                >
                                  v0.4.26-nightly.2018.9.20+commit.2150aea3
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.19+commit.7c15f6b1"
                                >
                                  v0.4.26-nightly.2018.9.19+commit.7c15f6b1
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.18+commit.fcb48bce"
                                >
                                  v0.4.26-nightly.2018.9.18+commit.fcb48bce
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.17+commit.2409986c"
                                >
                                  v0.4.26-nightly.2018.9.17+commit.2409986c
                                </option>
                                <option
                                  value="v0.4.26-nightly.2018.9.13+commit.8b089cc8"
                                >
                                  v0.4.26-nightly.2018.9.13+commit.8b089cc8
                                </option>
                                <option value="v0.4.25+commit.59dbf8f1">
                                  v0.4.25+commit.59dbf8f1
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.13+commit.15c8c0d2"
                                >
                                  v0.4.25-nightly.2018.9.13+commit.15c8c0d2
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.12+commit.9214c7c3"
                                >
                                  v0.4.25-nightly.2018.9.12+commit.9214c7c3
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.11+commit.d66e956a"
                                >
                                  v0.4.25-nightly.2018.9.11+commit.d66e956a
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.10+commit.86d85025"
                                >
                                  v0.4.25-nightly.2018.9.10+commit.86d85025
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.6+commit.f19cddd5"
                                >
                                  v0.4.25-nightly.2018.9.6+commit.f19cddd5
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.5+commit.a996ea26"
                                >
                                  v0.4.25-nightly.2018.9.5+commit.a996ea26
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.4+commit.f27d7edf"
                                >
                                  v0.4.25-nightly.2018.9.4+commit.f27d7edf
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.9.3+commit.0b9cc80b"
                                >
                                  v0.4.25-nightly.2018.9.3+commit.0b9cc80b
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.16+commit.a9e7ae29"
                                >
                                  v0.4.25-nightly.2018.8.16+commit.a9e7ae29
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.15+commit.2946b7cd"
                                >
                                  v0.4.25-nightly.2018.8.15+commit.2946b7cd
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.14+commit.6ca39739"
                                >
                                  v0.4.25-nightly.2018.8.14+commit.6ca39739
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.13+commit.a2c754b3"
                                >
                                  v0.4.25-nightly.2018.8.13+commit.a2c754b3
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.9+commit.63d071d6"
                                >
                                  v0.4.25-nightly.2018.8.9+commit.63d071d6
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.8+commit.d2ca9c82"
                                >
                                  v0.4.25-nightly.2018.8.8+commit.d2ca9c82
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.7+commit.cda3fbda"
                                >
                                  v0.4.25-nightly.2018.8.7+commit.cda3fbda
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.6+commit.3684151e"
                                >
                                  v0.4.25-nightly.2018.8.6+commit.3684151e
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.3+commit.04efbc9e"
                                >
                                  v0.4.25-nightly.2018.8.3+commit.04efbc9e
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.2+commit.6003ed2a"
                                >
                                  v0.4.25-nightly.2018.8.2+commit.6003ed2a
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.8.1+commit.21888e24"
                                >
                                  v0.4.25-nightly.2018.8.1+commit.21888e24
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.31+commit.75c1a9bd"
                                >
                                  v0.4.25-nightly.2018.7.31+commit.75c1a9bd
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.30+commit.9d09e21b"
                                >
                                  v0.4.25-nightly.2018.7.30+commit.9d09e21b
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.27+commit.bc51b0f6"
                                >
                                  v0.4.25-nightly.2018.7.27+commit.bc51b0f6
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.25+commit.ff8e9300"
                                >
                                  v0.4.25-nightly.2018.7.25+commit.ff8e9300
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.24+commit.fc68d22b"
                                >
                                  v0.4.25-nightly.2018.7.24+commit.fc68d22b
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.23+commit.79ddcc76"
                                >
                                  v0.4.25-nightly.2018.7.23+commit.79ddcc76
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.20+commit.d3000e70"
                                >
                                  v0.4.25-nightly.2018.7.20+commit.d3000e70
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.19+commit.e3c2f20f"
                                >
                                  v0.4.25-nightly.2018.7.19+commit.e3c2f20f
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.18+commit.b909df45"
                                >
                                  v0.4.25-nightly.2018.7.18+commit.b909df45
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.17+commit.56096e9c"
                                >
                                  v0.4.25-nightly.2018.7.17+commit.56096e9c
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.16+commit.98656423"
                                >
                                  v0.4.25-nightly.2018.7.16+commit.98656423
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.12+commit.ff9974e9"
                                >
                                  v0.4.25-nightly.2018.7.12+commit.ff9974e9
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.11+commit.07910c80"
                                >
                                  v0.4.25-nightly.2018.7.11+commit.07910c80
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.10+commit.5c404fcf"
                                >
                                  v0.4.25-nightly.2018.7.10+commit.5c404fcf
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.9+commit.c42583d2"
                                >
                                  v0.4.25-nightly.2018.7.9+commit.c42583d2
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.5+commit.b1ab81ef"
                                >
                                  v0.4.25-nightly.2018.7.5+commit.b1ab81ef
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.4+commit.47637224"
                                >
                                  v0.4.25-nightly.2018.7.4+commit.47637224
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.3+commit.09f3532e"
                                >
                                  v0.4.25-nightly.2018.7.3+commit.09f3532e
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.7.2+commit.a5608b31"
                                >
                                  v0.4.25-nightly.2018.7.2+commit.a5608b31
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.29+commit.c9cab803"
                                >
                                  v0.4.25-nightly.2018.6.29+commit.c9cab803
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.28+commit.42680629"
                                >
                                  v0.4.25-nightly.2018.6.28+commit.42680629
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.27+commit.b67dfa15"
                                >
                                  v0.4.25-nightly.2018.6.27+commit.b67dfa15
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.26+commit.24f124f8"
                                >
                                  v0.4.25-nightly.2018.6.26+commit.24f124f8
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.25+commit.b7003505"
                                >
                                  v0.4.25-nightly.2018.6.25+commit.b7003505
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.22+commit.9b67bdb3"
                                >
                                  v0.4.25-nightly.2018.6.22+commit.9b67bdb3
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.21+commit.0d104718"
                                >
                                  v0.4.25-nightly.2018.6.21+commit.0d104718
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.20+commit.ba7fbf11"
                                >
                                  v0.4.25-nightly.2018.6.20+commit.ba7fbf11
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.19+commit.c72e04c3"
                                >
                                  v0.4.25-nightly.2018.6.19+commit.c72e04c3
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.18+commit.4247b004"
                                >
                                  v0.4.25-nightly.2018.6.18+commit.4247b004
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.17+commit.1692f78b"
                                >
                                  v0.4.25-nightly.2018.6.17+commit.1692f78b
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.14+commit.baeabe1c"
                                >
                                  v0.4.25-nightly.2018.6.14+commit.baeabe1c
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.13+commit.3055e4ca"
                                >
                                  v0.4.25-nightly.2018.6.13+commit.3055e4ca
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.12+commit.56a965ea"
                                >
                                  v0.4.25-nightly.2018.6.12+commit.56a965ea
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.11+commit.d0355619"
                                >
                                  v0.4.25-nightly.2018.6.11+commit.d0355619
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.8+commit.81c5a6e4"
                                >
                                  v0.4.25-nightly.2018.6.8+commit.81c5a6e4
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.7+commit.ddd256a6"
                                >
                                  v0.4.25-nightly.2018.6.7+commit.ddd256a6
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.6+commit.59b35fa5"
                                >
                                  v0.4.25-nightly.2018.6.6+commit.59b35fa5
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.5+commit.7422cd73"
                                >
                                  v0.4.25-nightly.2018.6.5+commit.7422cd73
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.4+commit.0a074d84"
                                >
                                  v0.4.25-nightly.2018.6.4+commit.0a074d84
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.6.3+commit.ef8fb63b"
                                >
                                  v0.4.25-nightly.2018.6.3+commit.ef8fb63b
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.30+commit.3f3d6df2"
                                >
                                  v0.4.25-nightly.2018.5.30+commit.3f3d6df2
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.28+commit.0c223b03"
                                >
                                  v0.4.25-nightly.2018.5.28+commit.0c223b03
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.23+commit.18c651b7"
                                >
                                  v0.4.25-nightly.2018.5.23+commit.18c651b7
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.22+commit.849b1bd5"
                                >
                                  v0.4.25-nightly.2018.5.22+commit.849b1bd5
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.21+commit.e97f9b6b"
                                >
                                  v0.4.25-nightly.2018.5.21+commit.e97f9b6b
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.18+commit.4d7b092c"
                                >
                                  v0.4.25-nightly.2018.5.18+commit.4d7b092c
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.17+commit.4aa2f036"
                                >
                                  v0.4.25-nightly.2018.5.17+commit.4aa2f036
                                </option>
                                <option
                                  value="v0.4.25-nightly.2018.5.16+commit.3897c367"
                                >
                                  v0.4.25-nightly.2018.5.16+commit.3897c367
                                </option>
                                <option value="v0.4.24+commit.e67f0147">
                                  v0.4.24+commit.e67f0147
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.16+commit.7f965c86"
                                >
                                  v0.4.24-nightly.2018.5.16+commit.7f965c86
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.15+commit.b8b46099"
                                >
                                  v0.4.24-nightly.2018.5.15+commit.b8b46099
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.14+commit.7a669b39"
                                >
                                  v0.4.24-nightly.2018.5.14+commit.7a669b39
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.11+commit.43803b1a"
                                >
                                  v0.4.24-nightly.2018.5.11+commit.43803b1a
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.10+commit.85d417a8"
                                >
                                  v0.4.24-nightly.2018.5.10+commit.85d417a8
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.9+commit.1e953355"
                                >
                                  v0.4.24-nightly.2018.5.9+commit.1e953355
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.8+commit.0a63bc17"
                                >
                                  v0.4.24-nightly.2018.5.8+commit.0a63bc17
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.7+commit.6db7e09a"
                                >
                                  v0.4.24-nightly.2018.5.7+commit.6db7e09a
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.4+commit.81d61ca0"
                                >
                                  v0.4.24-nightly.2018.5.4+commit.81d61ca0
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.3+commit.72c3b3a2"
                                >
                                  v0.4.24-nightly.2018.5.3+commit.72c3b3a2
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.5.2+commit.dc18cde6"
                                >
                                  v0.4.24-nightly.2018.5.2+commit.dc18cde6
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.30+commit.9e61b25d"
                                >
                                  v0.4.24-nightly.2018.4.30+commit.9e61b25d
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.27+commit.1604a996"
                                >
                                  v0.4.24-nightly.2018.4.27+commit.1604a996
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.26+commit.ef2111a2"
                                >
                                  v0.4.24-nightly.2018.4.26+commit.ef2111a2
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.25+commit.81cca26f"
                                >
                                  v0.4.24-nightly.2018.4.25+commit.81cca26f
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.24+commit.258ae892"
                                >
                                  v0.4.24-nightly.2018.4.24+commit.258ae892
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.23+commit.c7ee2ca0"
                                >
                                  v0.4.24-nightly.2018.4.23+commit.c7ee2ca0
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.22+commit.2fae248d"
                                >
                                  v0.4.24-nightly.2018.4.22+commit.2fae248d
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.20+commit.0f328431"
                                >
                                  v0.4.24-nightly.2018.4.20+commit.0f328431
                                </option>
                                <option
                                  value="v0.4.24-nightly.2018.4.19+commit.27d79906"
                                >
                                  v0.4.24-nightly.2018.4.19+commit.27d79906
                                </option>
                                <option value="v0.4.23+commit.124ca40d">
                                  v0.4.23+commit.124ca40d
                                </option>
                                <option
                                  value="v0.4.23-nightly.2018.4.19+commit.ae834e3d"
                                >
                                  v0.4.23-nightly.2018.4.19+commit.ae834e3d
                                </option>
                                <option
                                  value="v0.4.23-nightly.2018.4.18+commit.85687a37"
                                >
                                  v0.4.23-nightly.2018.4.18+commit.85687a37
                                </option>
                                <option
                                  value="v0.4.23-nightly.2018.4.17+commit.5499db01"
                                >
                                  v0.4.23-nightly.2018.4.17+commit.5499db01
                                </option>
                                <option value="v0.4.22+commit.4cb486ee">
                                  v0.4.22+commit.4cb486ee
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.16+commit.d8030c9b"
                                >
                                  v0.4.22-nightly.2018.4.16+commit.d8030c9b
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.14+commit.73ca3e8a"
                                >
                                  v0.4.22-nightly.2018.4.14+commit.73ca3e8a
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.13+commit.2001cc6b"
                                >
                                  v0.4.22-nightly.2018.4.13+commit.2001cc6b
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.12+commit.c3dc67d0"
                                >
                                  v0.4.22-nightly.2018.4.12+commit.c3dc67d0
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.11+commit.b7b6d0ce"
                                >
                                  v0.4.22-nightly.2018.4.11+commit.b7b6d0ce
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.10+commit.27385d6d"
                                >
                                  v0.4.22-nightly.2018.4.10+commit.27385d6d
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.6+commit.9bd49516"
                                >
                                  v0.4.22-nightly.2018.4.6+commit.9bd49516
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.5+commit.c6adad93"
                                >
                                  v0.4.22-nightly.2018.4.5+commit.c6adad93
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.4+commit.920de496"
                                >
                                  v0.4.22-nightly.2018.4.4+commit.920de496
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.4.3+commit.3fbdd655"
                                >
                                  v0.4.22-nightly.2018.4.3+commit.3fbdd655
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.30+commit.326d656a"
                                >
                                  v0.4.22-nightly.2018.3.30+commit.326d656a
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.29+commit.c2ae33f8"
                                >
                                  v0.4.22-nightly.2018.3.29+commit.c2ae33f8
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.27+commit.af262281"
                                >
                                  v0.4.22-nightly.2018.3.27+commit.af262281
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.21+commit.8fd53c1c"
                                >
                                  v0.4.22-nightly.2018.3.21+commit.8fd53c1c
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.16+commit.2b2527f3"
                                >
                                  v0.4.22-nightly.2018.3.16+commit.2b2527f3
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.15+commit.3f1e0d84"
                                >
                                  v0.4.22-nightly.2018.3.15+commit.3f1e0d84
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.14+commit.c3f07b52"
                                >
                                  v0.4.22-nightly.2018.3.14+commit.c3f07b52
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.13+commit.f2614be9"
                                >
                                  v0.4.22-nightly.2018.3.13+commit.f2614be9
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.12+commit.c6e9dd13"
                                >
                                  v0.4.22-nightly.2018.3.12+commit.c6e9dd13
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.8+commit.fbc29f6d"
                                >
                                  v0.4.22-nightly.2018.3.8+commit.fbc29f6d
                                </option>
                                <option
                                  value="v0.4.22-nightly.2018.3.7+commit.b5e804b8"
                                >
                                  v0.4.22-nightly.2018.3.7+commit.b5e804b8
                                </option>
                                <option value="v0.4.21+commit.dfe3193c">
                                  v0.4.21+commit.dfe3193c
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.3.7+commit.bd7bc7c4"
                                >
                                  v0.4.21-nightly.2018.3.7+commit.bd7bc7c4
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.3.6+commit.a9e02acc"
                                >
                                  v0.4.21-nightly.2018.3.6+commit.a9e02acc
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.3.5+commit.cd6ffbdf"
                                >
                                  v0.4.21-nightly.2018.3.5+commit.cd6ffbdf
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.3.1+commit.cf6720ea"
                                >
                                  v0.4.21-nightly.2018.3.1+commit.cf6720ea
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.28+commit.ac5485a2"
                                >
                                  v0.4.21-nightly.2018.2.28+commit.ac5485a2
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.27+commit.415ac2ae"
                                >
                                  v0.4.21-nightly.2018.2.27+commit.415ac2ae
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.26+commit.cd2d8936"
                                >
                                  v0.4.21-nightly.2018.2.26+commit.cd2d8936
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.23+commit.cae6cc2c"
                                >
                                  v0.4.21-nightly.2018.2.23+commit.cae6cc2c
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.22+commit.71a34abd"
                                >
                                  v0.4.21-nightly.2018.2.22+commit.71a34abd
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.21+commit.16c7eabc"
                                >
                                  v0.4.21-nightly.2018.2.21+commit.16c7eabc
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.20+commit.dcc4083b"
                                >
                                  v0.4.21-nightly.2018.2.20+commit.dcc4083b
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.19+commit.839acafb"
                                >
                                  v0.4.21-nightly.2018.2.19+commit.839acafb
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.16+commit.3f7e82d0"
                                >
                                  v0.4.21-nightly.2018.2.16+commit.3f7e82d0
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.15+commit.f4aa05f3"
                                >
                                  v0.4.21-nightly.2018.2.15+commit.f4aa05f3
                                </option>
                                <option
                                  value="v0.4.21-nightly.2018.2.14+commit.bb3b327c"
                                >
                                  v0.4.21-nightly.2018.2.14+commit.bb3b327c
                                </option>
                                <option value="v0.4.20+commit.3155dd80">
                                  v0.4.20+commit.3155dd80
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.2.13+commit.27ef9794"
                                >
                                  v0.4.20-nightly.2018.2.13+commit.27ef9794
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.2.12+commit.954903b5"
                                >
                                  v0.4.20-nightly.2018.2.12+commit.954903b5
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.29+commit.a668b9de"
                                >
                                  v0.4.20-nightly.2018.1.29+commit.a668b9de
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.26+commit.bbad48bb"
                                >
                                  v0.4.20-nightly.2018.1.26+commit.bbad48bb
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.25+commit.e7afde95"
                                >
                                  v0.4.20-nightly.2018.1.25+commit.e7afde95
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.24+commit.b177352a"
                                >
                                  v0.4.20-nightly.2018.1.24+commit.b177352a
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.23+commit.31aaf433"
                                >
                                  v0.4.20-nightly.2018.1.23+commit.31aaf433
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.22+commit.e5def2da"
                                >
                                  v0.4.20-nightly.2018.1.22+commit.e5def2da
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.19+commit.eba46a65"
                                >
                                  v0.4.20-nightly.2018.1.19+commit.eba46a65
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.18+commit.33723c45"
                                >
                                  v0.4.20-nightly.2018.1.18+commit.33723c45
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.17+commit.4715167e"
                                >
                                  v0.4.20-nightly.2018.1.17+commit.4715167e
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.15+commit.14fcbd65"
                                >
                                  v0.4.20-nightly.2018.1.15+commit.14fcbd65
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.11+commit.0c20b6da"
                                >
                                  v0.4.20-nightly.2018.1.11+commit.0c20b6da
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.10+commit.a75d5333"
                                >
                                  v0.4.20-nightly.2018.1.10+commit.a75d5333
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.6+commit.2548228b"
                                >
                                  v0.4.20-nightly.2018.1.6+commit.2548228b
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.5+commit.bca01f8f"
                                >
                                  v0.4.20-nightly.2018.1.5+commit.bca01f8f
                                </option>
                                <option
                                  value="v0.4.20-nightly.2018.1.4+commit.a0771691"
                                >
                                  v0.4.20-nightly.2018.1.4+commit.a0771691
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.20+commit.efc198d5"
                                >
                                  v0.4.20-nightly.2017.12.20+commit.efc198d5
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.19+commit.2d800e67"
                                >
                                  v0.4.20-nightly.2017.12.19+commit.2d800e67
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.18+commit.37b70e8e"
                                >
                                  v0.4.20-nightly.2017.12.18+commit.37b70e8e
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.14+commit.3d1830f3"
                                >
                                  v0.4.20-nightly.2017.12.14+commit.3d1830f3
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.13+commit.bfc54463"
                                >
                                  v0.4.20-nightly.2017.12.13+commit.bfc54463
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.12+commit.1ddd4e2b"
                                >
                                  v0.4.20-nightly.2017.12.12+commit.1ddd4e2b
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.11+commit.4a1f18c9"
                                >
                                  v0.4.20-nightly.2017.12.11+commit.4a1f18c9
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.8+commit.226bfe5b"
                                >
                                  v0.4.20-nightly.2017.12.8+commit.226bfe5b
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.6+commit.c2109436"
                                >
                                  v0.4.20-nightly.2017.12.6+commit.c2109436
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.5+commit.b47e023d"
                                >
                                  v0.4.20-nightly.2017.12.5+commit.b47e023d
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.4+commit.240c79e6"
                                >
                                  v0.4.20-nightly.2017.12.4+commit.240c79e6
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.12.1+commit.6d8d0393"
                                >
                                  v0.4.20-nightly.2017.12.1+commit.6d8d0393
                                </option>
                                <option
                                  value="v0.4.20-nightly.2017.11.30+commit.cb16a5d3"
                                >
                                  v0.4.20-nightly.2017.11.30+commit.cb16a5d3
                                </option>
                                <option value="v0.4.19+commit.c4cbbb05">
                                  v0.4.19+commit.c4cbbb05
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.30+commit.f5a2508e"
                                >
                                  v0.4.19-nightly.2017.11.30+commit.f5a2508e
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.29+commit.7c69d88f"
                                >
                                  v0.4.19-nightly.2017.11.29+commit.7c69d88f
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.22+commit.f22ac8fc"
                                >
                                  v0.4.19-nightly.2017.11.22+commit.f22ac8fc
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.21+commit.5c9e273d"
                                >
                                  v0.4.19-nightly.2017.11.21+commit.5c9e273d
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.17+commit.2b5ef806"
                                >
                                  v0.4.19-nightly.2017.11.17+commit.2b5ef806
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.16+commit.58e452d1"
                                >
                                  v0.4.19-nightly.2017.11.16+commit.58e452d1
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.15+commit.e3206d8e"
                                >
                                  v0.4.19-nightly.2017.11.15+commit.e3206d8e
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.14+commit.bc39e730"
                                >
                                  v0.4.19-nightly.2017.11.14+commit.bc39e730
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.13+commit.060b2c2b"
                                >
                                  v0.4.19-nightly.2017.11.13+commit.060b2c2b
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.11.11+commit.284c3839"
                                >
                                  v0.4.19-nightly.2017.11.11+commit.284c3839
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.29+commit.eb140bc6"
                                >
                                  v0.4.19-nightly.2017.10.29+commit.eb140bc6
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.28+commit.f9b24009"
                                >
                                  v0.4.19-nightly.2017.10.28+commit.f9b24009
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.27+commit.1e085f85"
                                >
                                  v0.4.19-nightly.2017.10.27+commit.1e085f85
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.26+commit.59d4dfbd"
                                >
                                  v0.4.19-nightly.2017.10.26+commit.59d4dfbd
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.24+commit.1313e9d8"
                                >
                                  v0.4.19-nightly.2017.10.24+commit.1313e9d8
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.23+commit.dc6b1f02"
                                >
                                  v0.4.19-nightly.2017.10.23+commit.dc6b1f02
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.20+commit.bdd2858b"
                                >
                                  v0.4.19-nightly.2017.10.20+commit.bdd2858b
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.19+commit.c58d9d2c"
                                >
                                  v0.4.19-nightly.2017.10.19+commit.c58d9d2c
                                </option>
                                <option
                                  value="v0.4.19-nightly.2017.10.18+commit.f7ca2421"
                                >
                                  v0.4.19-nightly.2017.10.18+commit.f7ca2421
                                </option>
                                <option value="v0.4.18+commit.9cf6e910">
                                  v0.4.18+commit.9cf6e910
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.18+commit.e854da1a"
                                >
                                  v0.4.18-nightly.2017.10.18+commit.e854da1a
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.17+commit.8fbfd62d"
                                >
                                  v0.4.18-nightly.2017.10.17+commit.8fbfd62d
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.16+commit.dbc8655b"
                                >
                                  v0.4.18-nightly.2017.10.16+commit.dbc8655b
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.15+commit.a74c9aef"
                                >
                                  v0.4.18-nightly.2017.10.15+commit.a74c9aef
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.10+commit.c35496bf"
                                >
                                  v0.4.18-nightly.2017.10.10+commit.c35496bf
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.9+commit.6f832cac"
                                >
                                  v0.4.18-nightly.2017.10.9+commit.6f832cac
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.6+commit.961f8746"
                                >
                                  v0.4.18-nightly.2017.10.6+commit.961f8746
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.5+commit.995b5525"
                                >
                                  v0.4.18-nightly.2017.10.5+commit.995b5525
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.4+commit.0c3888ab"
                                >
                                  v0.4.18-nightly.2017.10.4+commit.0c3888ab
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.3+commit.5c284589"
                                >
                                  v0.4.18-nightly.2017.10.3+commit.5c284589
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.10.2+commit.c6161030"
                                >
                                  v0.4.18-nightly.2017.10.2+commit.c6161030
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.9.29+commit.b9218468"
                                >
                                  v0.4.18-nightly.2017.9.29+commit.b9218468
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.9.28+commit.4d01d086"
                                >
                                  v0.4.18-nightly.2017.9.28+commit.4d01d086
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.9.27+commit.809d5ce1"
                                >
                                  v0.4.18-nightly.2017.9.27+commit.809d5ce1
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.9.26+commit.eb5a6aac"
                                >
                                  v0.4.18-nightly.2017.9.26+commit.eb5a6aac
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.9.25+commit.a72237f2"
                                >
                                  v0.4.18-nightly.2017.9.25+commit.a72237f2
                                </option>
                                <option
                                  value="v0.4.18-nightly.2017.9.22+commit.a2a58789"
                                >
                                  v0.4.18-nightly.2017.9.22+commit.a2a58789
                                </option>
                                <option value="v0.4.17+commit.bdeb9e52">
                                  v0.4.17+commit.bdeb9e52
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.21+commit.725b4fc2"
                                >
                                  v0.4.17-nightly.2017.9.21+commit.725b4fc2
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.20+commit.c0b3e5b0"
                                >
                                  v0.4.17-nightly.2017.9.20+commit.c0b3e5b0
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.19+commit.1fc71bd7"
                                >
                                  v0.4.17-nightly.2017.9.19+commit.1fc71bd7
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.18+commit.c289fd3d"
                                >
                                  v0.4.17-nightly.2017.9.18+commit.c289fd3d
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.16+commit.a0d17172"
                                >
                                  v0.4.17-nightly.2017.9.16+commit.a0d17172
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.14+commit.7dd372ce"
                                >
                                  v0.4.17-nightly.2017.9.14+commit.7dd372ce
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.12+commit.4770f8f4"
                                >
                                  v0.4.17-nightly.2017.9.12+commit.4770f8f4
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.11+commit.fbe24da1"
                                >
                                  v0.4.17-nightly.2017.9.11+commit.fbe24da1
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.6+commit.59223061"
                                >
                                  v0.4.17-nightly.2017.9.6+commit.59223061
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.5+commit.f242331c"
                                >
                                  v0.4.17-nightly.2017.9.5+commit.f242331c
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.9.4+commit.8283f836"
                                >
                                  v0.4.17-nightly.2017.9.4+commit.8283f836
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.8.31+commit.402d6e71"
                                >
                                  v0.4.17-nightly.2017.8.31+commit.402d6e71
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.8.29+commit.2d39a42d"
                                >
                                  v0.4.17-nightly.2017.8.29+commit.2d39a42d
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.8.28+commit.d15cde2a"
                                >
                                  v0.4.17-nightly.2017.8.28+commit.d15cde2a
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.8.25+commit.e945f458"
                                >
                                  v0.4.17-nightly.2017.8.25+commit.e945f458
                                </option>
                                <option
                                  value="v0.4.17-nightly.2017.8.24+commit.012d9f79"
                                >
                                  v0.4.17-nightly.2017.8.24+commit.012d9f79
                                </option>
                                <option value="v0.4.16+commit.d7661dd9">
                                  v0.4.16+commit.d7661dd9
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.24+commit.78c2dcac"
                                >
                                  v0.4.16-nightly.2017.8.24+commit.78c2dcac
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.23+commit.c5f11d93"
                                >
                                  v0.4.16-nightly.2017.8.23+commit.c5f11d93
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.22+commit.f874fc28"
                                >
                                  v0.4.16-nightly.2017.8.22+commit.f874fc28
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.21+commit.0cf60488"
                                >
                                  v0.4.16-nightly.2017.8.21+commit.0cf60488
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.16+commit.83561e13"
                                >
                                  v0.4.16-nightly.2017.8.16+commit.83561e13
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.15+commit.dca1f45c"
                                >
                                  v0.4.16-nightly.2017.8.15+commit.dca1f45c
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.14+commit.4d9790b6"
                                >
                                  v0.4.16-nightly.2017.8.14+commit.4d9790b6
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.11+commit.c84de7fa"
                                >
                                  v0.4.16-nightly.2017.8.11+commit.c84de7fa
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.10+commit.41e3cbe0"
                                >
                                  v0.4.16-nightly.2017.8.10+commit.41e3cbe0
                                </option>
                                <option
                                  value="v0.4.16-nightly.2017.8.9+commit.81887bc7"
                                >
                                  v0.4.16-nightly.2017.8.9+commit.81887bc7
                                </option>
                                <option value="v0.4.15+commit.8b45bddb">
                                  v0.4.15+commit.8b45bddb
                                </option>
                                <option value="v0.4.15+commit.bbb8e64f">
                                  v0.4.15+commit.bbb8e64f
                                </option>
                                <option
                                  value="v0.4.15-nightly.2017.8.8+commit.41e72436"
                                >
                                  v0.4.15-nightly.2017.8.8+commit.41e72436
                                </option>
                                <option
                                  value="v0.4.15-nightly.2017.8.7+commit.212454a9"
                                >
                                  v0.4.15-nightly.2017.8.7+commit.212454a9
                                </option>
                                <option
                                  value="v0.4.15-nightly.2017.8.4+commit.e48730fe"
                                >
                                  v0.4.15-nightly.2017.8.4+commit.e48730fe
                                </option>
                                <option
                                  value="v0.4.15-nightly.2017.8.2+commit.04166ce1"
                                >
                                  v0.4.15-nightly.2017.8.2+commit.04166ce1
                                </option>
                                <option
                                  value="v0.4.15-nightly.2017.8.1+commit.7e07eb6e"
                                >
                                  v0.4.15-nightly.2017.8.1+commit.7e07eb6e
                                </option>
                                <option
                                  value="v0.4.15-nightly.2017.7.31+commit.93f90eb2"
                                >
                                  v0.4.15-nightly.2017.7.31+commit.93f90eb2
                                </option>
                                <option value="v0.4.14+commit.c2215d46">
                                  v0.4.14+commit.c2215d46
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.31+commit.22326189"
                                >
                                  v0.4.14-nightly.2017.7.31+commit.22326189
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.28+commit.7e40def6"
                                >
                                  v0.4.14-nightly.2017.7.28+commit.7e40def6
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.27+commit.1298a8df"
                                >
                                  v0.4.14-nightly.2017.7.27+commit.1298a8df
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.26+commit.0d701c94"
                                >
                                  v0.4.14-nightly.2017.7.26+commit.0d701c94
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.25+commit.3c2b710b"
                                >
                                  v0.4.14-nightly.2017.7.25+commit.3c2b710b
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.24+commit.cfb11ff7"
                                >
                                  v0.4.14-nightly.2017.7.24+commit.cfb11ff7
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.21+commit.75b48616"
                                >
                                  v0.4.14-nightly.2017.7.21+commit.75b48616
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.20+commit.d70974ea"
                                >
                                  v0.4.14-nightly.2017.7.20+commit.d70974ea
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.19+commit.3ad326be"
                                >
                                  v0.4.14-nightly.2017.7.19+commit.3ad326be
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.18+commit.c167a31b"
                                >
                                  v0.4.14-nightly.2017.7.18+commit.c167a31b
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.14+commit.7c97546f"
                                >
                                  v0.4.14-nightly.2017.7.14+commit.7c97546f
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.13+commit.2b33e0bc"
                                >
                                  v0.4.14-nightly.2017.7.13+commit.2b33e0bc
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.12+commit.b981ef20"
                                >
                                  v0.4.14-nightly.2017.7.12+commit.b981ef20
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.11+commit.0b17ff1b"
                                >
                                  v0.4.14-nightly.2017.7.11+commit.0b17ff1b
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.10+commit.6fa5d47f"
                                >
                                  v0.4.14-nightly.2017.7.10+commit.6fa5d47f
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.9+commit.aafcc360"
                                >
                                  v0.4.14-nightly.2017.7.9+commit.aafcc360
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.8+commit.7d1ddfc6"
                                >
                                  v0.4.14-nightly.2017.7.8+commit.7d1ddfc6
                                </option>
                                <option
                                  value="v0.4.14-nightly.2017.7.6+commit.08dade9f"
                                >
                                  v0.4.14-nightly.2017.7.6+commit.08dade9f
                                </option>
                                <option value="v0.4.13+commit.0fb4cb1a">
                                  v0.4.13+commit.0fb4cb1a
                                </option>
                                <option
                                  value="v0.4.13-nightly.2017.7.6+commit.40d4ee49"
                                >
                                  v0.4.13-nightly.2017.7.6+commit.40d4ee49
                                </option>
                                <option
                                  value="v0.4.13-nightly.2017.7.5+commit.2b505e7a"
                                >
                                  v0.4.13-nightly.2017.7.5+commit.2b505e7a
                                </option>
                                <option
                                  value="v0.4.13-nightly.2017.7.4+commit.331b0b1c"
                                >
                                  v0.4.13-nightly.2017.7.4+commit.331b0b1c
                                </option>
                                <option
                                  value="v0.4.13-nightly.2017.7.3+commit.6e4e627b"
                                >
                                  v0.4.13-nightly.2017.7.3+commit.6e4e627b
                                </option>
                                <option value="v0.4.12+commit.194ff033">
                                  v0.4.12+commit.194ff033
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.7.3+commit.0c7530a8"
                                >
                                  v0.4.12-nightly.2017.7.3+commit.0c7530a8
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.7.1+commit.06f8949f"
                                >
                                  v0.4.12-nightly.2017.7.1+commit.06f8949f
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.30+commit.568e7520"
                                >
                                  v0.4.12-nightly.2017.6.30+commit.568e7520
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.29+commit.f5372cda"
                                >
                                  v0.4.12-nightly.2017.6.29+commit.f5372cda
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.28+commit.e19c4125"
                                >
                                  v0.4.12-nightly.2017.6.28+commit.e19c4125
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.27+commit.bc31d496"
                                >
                                  v0.4.12-nightly.2017.6.27+commit.bc31d496
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.26+commit.f8794892"
                                >
                                  v0.4.12-nightly.2017.6.26+commit.f8794892
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.25+commit.29b8cdb5"
                                >
                                  v0.4.12-nightly.2017.6.25+commit.29b8cdb5
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.23+commit.793f05fa"
                                >
                                  v0.4.12-nightly.2017.6.23+commit.793f05fa
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.22+commit.1c54ce2a"
                                >
                                  v0.4.12-nightly.2017.6.22+commit.1c54ce2a
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.21+commit.ac977cdf"
                                >
                                  v0.4.12-nightly.2017.6.21+commit.ac977cdf
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.20+commit.cb5f2f90"
                                >
                                  v0.4.12-nightly.2017.6.20+commit.cb5f2f90
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.19+commit.0c75afb2"
                                >
                                  v0.4.12-nightly.2017.6.19+commit.0c75afb2
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.16+commit.17de4a07"
                                >
                                  v0.4.12-nightly.2017.6.16+commit.17de4a07
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.15+commit.71fea1e3"
                                >
                                  v0.4.12-nightly.2017.6.15+commit.71fea1e3
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.14+commit.43cfab70"
                                >
                                  v0.4.12-nightly.2017.6.14+commit.43cfab70
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.13+commit.0c8c2091"
                                >
                                  v0.4.12-nightly.2017.6.13+commit.0c8c2091
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.12+commit.496c2a20"
                                >
                                  v0.4.12-nightly.2017.6.12+commit.496c2a20
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.9+commit.76667fed"
                                >
                                  v0.4.12-nightly.2017.6.9+commit.76667fed
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.8+commit.51fcfbcf"
                                >
                                  v0.4.12-nightly.2017.6.8+commit.51fcfbcf
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.6+commit.243e389f"
                                >
                                  v0.4.12-nightly.2017.6.6+commit.243e389f
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.6.1+commit.96de7a83"
                                >
                                  v0.4.12-nightly.2017.6.1+commit.96de7a83
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.30+commit.254b5572"
                                >
                                  v0.4.12-nightly.2017.5.30+commit.254b5572
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.29+commit.4a5dc6a4"
                                >
                                  v0.4.12-nightly.2017.5.29+commit.4a5dc6a4
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.26+commit.e43ff797"
                                >
                                  v0.4.12-nightly.2017.5.26+commit.e43ff797
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.24+commit.cf639f48"
                                >
                                  v0.4.12-nightly.2017.5.24+commit.cf639f48
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.23+commit.14b22150"
                                >
                                  v0.4.12-nightly.2017.5.23+commit.14b22150
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.22+commit.e3af0640"
                                >
                                  v0.4.12-nightly.2017.5.22+commit.e3af0640
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.19+commit.982f6613"
                                >
                                  v0.4.12-nightly.2017.5.19+commit.982f6613
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.18+commit.6f9428e9"
                                >
                                  v0.4.12-nightly.2017.5.18+commit.6f9428e9
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.17+commit.b4c6877a"
                                >
                                  v0.4.12-nightly.2017.5.17+commit.b4c6877a
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.16+commit.2ba87fe8"
                                >
                                  v0.4.12-nightly.2017.5.16+commit.2ba87fe8
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.11+commit.242e4318"
                                >
                                  v0.4.12-nightly.2017.5.11+commit.242e4318
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.10+commit.a6586f75"
                                >
                                  v0.4.12-nightly.2017.5.10+commit.a6586f75
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.6+commit.822c9057"
                                >
                                  v0.4.12-nightly.2017.5.6+commit.822c9057
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.5+commit.0582fcb9"
                                >
                                  v0.4.12-nightly.2017.5.5+commit.0582fcb9
                                </option>
                                <option
                                  value="v0.4.12-nightly.2017.5.4+commit.025b32d9"
                                >
                                  v0.4.12-nightly.2017.5.4+commit.025b32d9
                                </option>
                                <option value="v0.4.11+commit.68ef5810">
                                  v0.4.11+commit.68ef5810
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.5.3+commit.1aa0f77a"
                                >
                                  v0.4.11-nightly.2017.5.3+commit.1aa0f77a
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.5.2+commit.5aeb6352"
                                >
                                  v0.4.11-nightly.2017.5.2+commit.5aeb6352
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.28+commit.f33614e1"
                                >
                                  v0.4.11-nightly.2017.4.28+commit.f33614e1
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.27+commit.abe77f48"
                                >
                                  v0.4.11-nightly.2017.4.27+commit.abe77f48
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.26+commit.3cbdf6d4"
                                >
                                  v0.4.11-nightly.2017.4.26+commit.3cbdf6d4
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.25+commit.c3b839ca"
                                >
                                  v0.4.11-nightly.2017.4.25+commit.c3b839ca
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.24+commit.a9f42157"
                                >
                                  v0.4.11-nightly.2017.4.24+commit.a9f42157
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.22+commit.aa441668"
                                >
                                  v0.4.11-nightly.2017.4.22+commit.aa441668
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.21+commit.e3eea9fc"
                                >
                                  v0.4.11-nightly.2017.4.21+commit.e3eea9fc
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.20+commit.6468955f"
                                >
                                  v0.4.11-nightly.2017.4.20+commit.6468955f
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.18+commit.82628a80"
                                >
                                  v0.4.11-nightly.2017.4.18+commit.82628a80
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.13+commit.138c952a"
                                >
                                  v0.4.11-nightly.2017.4.13+commit.138c952a
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.4.10+commit.9fe20650"
                                >
                                  v0.4.11-nightly.2017.4.10+commit.9fe20650
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.29+commit.fefb3fad"
                                >
                                  v0.4.11-nightly.2017.3.29+commit.fefb3fad
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.28+commit.215184ef"
                                >
                                  v0.4.11-nightly.2017.3.28+commit.215184ef
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.27+commit.9d769a56"
                                >
                                  v0.4.11-nightly.2017.3.27+commit.9d769a56
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.22+commit.74d7c513"
                                >
                                  v0.4.11-nightly.2017.3.22+commit.74d7c513
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.21+commit.6fb27dee"
                                >
                                  v0.4.11-nightly.2017.3.21+commit.6fb27dee
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.20+commit.57bc763e"
                                >
                                  v0.4.11-nightly.2017.3.20+commit.57bc763e
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.17+commit.2f2ad42c"
                                >
                                  v0.4.11-nightly.2017.3.17+commit.2f2ad42c
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.16+commit.a2eb2c0a"
                                >
                                  v0.4.11-nightly.2017.3.16+commit.a2eb2c0a
                                </option>
                                <option
                                  value="v0.4.11-nightly.2017.3.15+commit.0157b86c"
                                >
                                  v0.4.11-nightly.2017.3.15+commit.0157b86c
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 col-sm-12">
                          <div class="js-form-message form-group">
                            <label for="ddlOptimization" id="lblOptimization"
                              >Optimization</label
                            >
                            <div
                              class="
                                js-focus-state
                                input-group input-group-sm
                                mb-2
                              "
                            >
                              <select
                                name="ctl00$ContentPlaceHolder1$ddlOptimization"
                                id="ContentPlaceHolder1_ddlOptimization"
                                class="custom-select custom-select-sm"
                                v-model="optValue"
                              >
                                <option value="true">Yes</option>
                                <option selected="selected" value="false">
                                  No
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-md-12 col-sm-12">
                          <br />
                          <div class="card">
                            <div
                              class="mt-3 mr-2 ml-3 js-form-message form-group"
                            >
                              <label for="txtSourceCode" class="d-block">
                                <b
                                  >Please select the Solidity (*.sol) files for
                                  upload</b
                                >
                                <span class="text-danger">*</span><br />
                              </label>
                              Step 1:
                              <input
                                type="file"
                                ref="refFile"
                                multiple="multiple"
                                name="ctl00$ContentPlaceHolder1$FileUpload1"
                                id="ContentPlaceHolder1_FileUpload1"
                                title="CTRL click to select Multiple files"
                                accept=".sol"
                                @change="fileLoad"
                              />

                              <br />
                              <br />

                              <span
                                id="ContentPlaceHolder1_UploadStatusLabel"
                              ></span>
                              <div class="mt-4"></div>
                              <input
                                type="hidden"
                                name="ctl00$ContentPlaceHolder1$sessid"
                                id="ContentPlaceHolder1_sessid"
                                value="ac832d35-6e9a-4cd3-811e-1d80a04b76cf"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <br />

                      <div class="js-form-message mb-4" v-if="false">
                        <label
                          for="txtSourceCode"
                          class="d-block"
                          id="lblSourceCode"
                        >
                          <b>Enter the Solidity Contract Code below</b>
                          <span class="text-danger">*</span>
                          <button
                            id="btnFetchFromGist"
                            class="
                              btn btn-xss btn-soft-secondary
                              fa-pull-right
                              mb-2
                            "
                            rel="tooltip"
                            title=""
                            type="button"
                            data-toggle="modal"
                            data-target="#myModal"
                            data-original-title="Fetch code from github gist and paste below"
                          >
                            <i class="fab fa-github mr-1"></i>Fetch from Gist
                          </button>
                        </label>
                        <textarea
                          name="ctl00$ContentPlaceHolder1$txtSourceCode"
                          rows="10"
                          cols="20"
                          id="ContentPlaceHolder1_txtSourceCode"
                          class="form-control form-control-sm w-100 mb-1"
                          spellcheck="false"
                          required=""
                          data-msg="Required"
                          data-error-class="u-has-error"
                          data-success-class="u-has-success"
                        ></textarea>
                        <span
                          id="ContentPlaceHolder1_RequiredFieldValidator1"
                          style="visibility: hidden"
                        ></span>
                      </div>
                      <div id="basicsAccordion">
                        <div class="card mb-3">
                          <div
                            class="card-header card-collapse"
                            id="basicsHeadingTwo"
                          >
                            <h5 class="mb-0">
                              <button
                                type="button"
                                class="
                                  btn btn-link btn-block
                                  d-flex
                                  justify-content-between
                                  card-btn
                                  collapsed
                                  p-3
                                "
                                data-toggle="collapse"
                                data-target="#basicsCollapseTwo"
                                aria-expanded="false"
                                aria-controls="basicsCollapseTwo"
                                @click="twoShow"
                              >
                                <label
                                  >Contract Library Address
                                  <span class="text-secondary"
                                    >(for contracts that use libraries, supports
                                    up to 10 libraries)</span
                                  ></label
                                >
                                <span class="card-btn-arrow">
                                  <span class="fas fa-arrow-down small"></span>
                                </span>
                              </button>
                            </h5>
                          </div>
                          <div
                            id="basicsCollapseTwo"
                            class="collapse"
                            :class="{ show: twoIfShow }"
                            aria-labelledby="basicsHeadingTwo"
                            data-parent="#basicsAccordion"
                          >
                            <div class="card-body">
                              <div class="col-md-12">
                                <span class="text-secondary"
                                  ><b
                                    >Note: Library names are case sensitive and
                                    affects the keccak library hash</b
                                  ></span
                                ><br /><br />
                                <div
                                  class="d-md-flex mb-3"
                                  v-for="(item, index) in libraryList"
                                  :key="index"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_{{ index + 1 }} Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName1"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName1"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      v-model="item.filename"
                                      data-toggle="tooltip"
                                      title=""
                                      rel="tooltip"
                                      data-placement="top"
                                      data-original-title="This option ONLY applies to contracts that use libraries. The source code should contain the concatenated contract and library source code in a single page"
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_{{ index + 1 }} Contract
                                      Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress1"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress1"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      data-toggle="tooltip"
                                      title=""
                                      rel="tooltip"
                                      data-placement="top"
                                      type="search"
                                      placeholder="0x..."
                                      data-original-title="Corresponding Contract Library Address"
                                      v-model="item.l"
                                    />
                                  </div>
                                </div>
                                <!-- <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_2"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_2 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName2"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName2"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_2 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress2"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress2"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_3"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_3 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName3"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName3"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_3 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress3"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress3"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_4"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_4 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName4"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName4"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_4 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress4"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress4"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_5"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_5 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName5"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName5"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_5 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress5"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress5"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_6"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_6 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName6"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName6"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_6 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress6"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress6"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_7"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_7 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName7"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName7"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_7 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress7"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress7"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_8"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_8 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName8"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName8"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_8 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress8"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress8"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_9"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-3
                                        mb-1
                                      "
                                      >Library_9 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName9"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName9"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_9 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress9"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress9"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div>
                                <div
                                  class="d-md-flex mb-3"
                                  id="extralibraries_10"
                                >
                                  <div class="form-inline mr-md-3 mb-2 mb-md-0">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_10 Name:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryName10"
                                      type="text"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryName10"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                    />
                                  </div>
                                  <div
                                    class="
                                      d-none d-md-block
                                      align-self-end
                                      mr-md-3
                                      mb-1
                                    "
                                  >
                                    <span
                                      class="
                                        btn btn-xs btn-icon btn-soft-secondary
                                        rounded-circle
                                      "
                                      ><i
                                        class="
                                          fa fa-long-arrow-alt-right
                                          btn-icon__inner
                                        "
                                      ></i
                                    ></span>
                                  </div>
                                  <div class="form-inline">
                                    <label
                                      class="
                                        text-monospace text-secondary
                                        mr-sm-2
                                        mb-1
                                      "
                                      >Library_10 Contract Address:</label
                                    >
                                    <input
                                      name="ctl00$ContentPlaceHolder1$txtLibraryAddress10"
                                      maxlength="42"
                                      id="ContentPlaceHolder1_txtLibraryAddress10"
                                      class="
                                        form-control form-control-xss
                                        w-100
                                      "
                                      type="search"
                                      placeholder="0x..."
                                    />
                                  </div>
                                </div> -->
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="card mb-3">
                          <div
                            class="card-header card-collapse"
                            id="basicsHeadingThree"
                          >
                            <h5 class="mb-0">
                              <button
                                type="button"
                                class="
                                  btn btn-link btn-block
                                  d-flex
                                  justify-content-between
                                  card-btn
                                  collapsed
                                  p-3
                                "
                                data-toggle="collapse"
                                data-target="#basicsCollapseThree"
                                aria-expanded="false"
                                aria-controls="basicsCollapseThree"
                                @click="threeShow"
                              >
                                <label
                                  >Misc Settings
                                  <span class="text-secondary"
                                    >(Runs, EvmVersion &amp; License Type
                                    settings)</span
                                  ></label
                                >
                                <span class="card-btn-arrow">
                                  <span class="fas fa-arrow-down small"></span>
                                </span>
                              </button>
                            </h5>
                          </div>
                          <div
                            id="basicsCollapseThree"
                            class="collapse"
                            :class="{ show: threeIfShow }"
                            aria-labelledby="basicsHeadingThree"
                            data-parent="#basicsAccordion"
                          >
                            <div class="card-body">
                              <div class="row mb-4">
                                <div class="col-md-4 mb-2">
                                  <label for="txtRuns"
                                    >Runs
                                    <span
                                      class="
                                        d-inline-block
                                        d-md-none
                                        d-lg-inline-block
                                      "
                                      >(Optimizer)</span
                                    ></label
                                  >
                                  <input
                                    name="ctl00$ContentPlaceHolder1$txtRuns"
                                    type="text"
                                    v-model="runValue"
                                    maxlength="8"
                                    id="ContentPlaceHolder1_txtRuns"
                                    class="form-control form-control-sm"
                                    required=""
                                    data-rule-maxlength="8"
                                    title=""
                                    data-success-class="u-has-success"
                                    data-rule-minlength="1"
                                    data-error-class="u-has-error"
                                    data-msg-minlength="Invalid Length"
                                    data-msg="Required"
                                    data-toggle="tooltip"
                                    data-original-title="Do not change if you are unsure. Previous versions of truffle defaulted to a value of 0"
                                  /><span
                                    id="ContentPlaceHolder1_RequiredFieldValidator1"
                                    style="visibility: hidden"
                                  ></span>
                                  <span
                                    id="ContentPlaceHolder1_ctl01"
                                    style="visibility: hidden"
                                  ></span>
                                </div>
                                <div class="col-md-4">
                                  <label>EVM Version to target</label>
                                  <select
                                    name="ctl00$ContentPlaceHolder1$ddlEvmVersion"
                                    id="ContentPlaceHolder1_ddlEvmVersion"
                                    class="custom-select custom-select-sm mb-1"
                                    data-toggle="tooltip"
                                    title=""
                                    v-model="evmVersion"
                                    data-original-title="A list of target EVM versions and the compiler-relevant changes introduced at each version. Backward compatibility is not guaranteed between each version."
                                  >
                                    <option selected="selected" value="">
                                      default (compiler defaults)
                                    </option>
                                    <option value="homestead">
                                      homestead (oldest version)
                                    </option>
                                    <option value="tangerineWhistle">
                                      tangerineWhistle
                                    </option>
                                    <option value="spuriousDragon">
                                      spuriousDragon
                                    </option>
                                    <option value="byzantium">
                                      byzantium (default for &lt;= v0.5.4)
                                    </option>
                                    <option value="constantinople">
                                      constantinople
                                    </option>
                                    <option value="petersburg">
                                      petersburg (default for &gt;= v0.5.5)
                                    </option>
                                    <option value="istanbul">
                                      istanbul (default for &gt;= v0.5.14)
                                    </option>
                                  </select>
                                </div>
                                <div class="col-md-4">
                                  <label
                                    >LicenseType
                                    <a
                                      href="/contract-license-types"
                                      target="_blank"
                                      data-toggle="tooltip"
                                      title=""
                                      data-original-title="Contract Source Code License Type, click for more info"
                                    ></a
                                  ></label>
                                  <select
                                    name="ctl00$ContentPlaceHolder1$ddlLicenseType"
                                    id="ContentPlaceHolder1_ddlLicenseType"
                                    title="Select a suitable license type"
                                    class="custom-select custom-select-sm"
                                    required=""
                                    data-msg="Required"
                                    data-error-class="u-has-error"
                                    data-success-class="u-has-success"
                                    v-model="licenseType"
                                  >
                                    <option
                                      selected="selected"
                                      value="No License (None)"
                                    >
                                      1) No License (None)
                                    </option>
                                    <option value="The Unlicense (Unlicense)">
                                      2) The Unlicense (Unlicense)
                                    </option>
                                    <option value="MIT License (MIT)">
                                      3) MIT License (MIT)
                                    </option>
                                    <option
                                      value="GNU General Public License v2.0 (GNU
                                      GPLv2)"
                                    >
                                      4) GNU General Public License v2.0 (GNU
                                      GPLv2)
                                    </option>
                                    <option
                                      value="GNU General Public License v3.0 (GNU
                                      GPLv3)"
                                    >
                                      5) GNU General Public License v3.0 (GNU
                                      GPLv3)
                                    </option>
                                    <option
                                      value="GNU Lesser General Public License v2.1
                                      (GNU LGPLv2.1)"
                                    >
                                      6) GNU Lesser General Public License v2.1
                                      (GNU LGPLv2.1)
                                    </option>
                                    <option
                                      value="GNU Lesser General Public License v3.0
                                      (GNU LGPLv3)"
                                    >
                                      7) GNU Lesser General Public License v3.0
                                      (GNU LGPLv3)
                                    </option>
                                    <option
                                      value="BSD 2-clause 'Simplified' license
                                      (BSD-2-Clause)"
                                    >
                                      8) BSD 2-clause "Simplified" license
                                      (BSD-2-Clause)
                                    </option>
                                    <option
                                      value="BSD 3-clause 'New' Or 'Revised' license
                                      (BSD-3-Clause)"
                                    >
                                      9) BSD 3-clause "New" Or "Revised" license
                                      (BSD-3-Clause)
                                    </option>
                                    <option
                                      value="Mozilla Public License 2.0 (MPL-2.0)"
                                    >
                                      10) Mozilla Public License 2.0 (MPL-2.0)
                                    </option>
                                    <option
                                      value="Open Software License 3.0 (OSL-3.0)"
                                    >
                                      11) Open Software License 3.0 (OSL-3.0)
                                    </option>
                                    <option value="Apache 2.0 (Apache-2.0)">
                                      12) Apache 2.0 (Apache-2.0)
                                    </option>
                                    <option
                                      value="GNU Affero General Public License (GNU
                                      AGPLv3)"
                                    >
                                      13) GNU Affero General Public License (GNU
                                      AGPLv3)
                                    </option>
                                    <option
                                      value="Business Source License (BSL 1.1)"
                                    >
                                      14) Business Source License (BSL 1.1)
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="text-center mb-4">
                        <div
                          id="ContentPlaceHolder1_recaptchaDiv"
                          class="d-flex justify-content-center my-5"
                        >
                          <div
                            class="g-recaptcha"
                            data-sitekey="6Le1YycTAAAAAJXqwosyiATvJ6Gs2NLn8VEzTVlS"
                          >
                            <div style="width: 304px; height: 78px">
                              <textarea
                                id="g-recaptcha-response"
                                name="g-recaptcha-response"
                                class="g-recaptcha-response"
                                style="
                                  width: 250px;
                                  height: 40px;
                                  border: 1px solid rgb(193, 193, 193);
                                  margin: 10px 25px;
                                  padding: 0px;
                                  resize: none;
                                  display: none;
                                "
                              ></textarea>
                            </div>
                            <iframe style="display: none"></iframe>
                          </div>
                        </div>
                        <input
                          type="button"
                          name="ctl00$ContentPlaceHolder1$btnSubmit"
                          value="Verify and Publish"
                          id="ContentPlaceHolder1_btnSubmit"
                          class="btn btn-primary mr-2 btn-submit"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Submit source code for verification"
                          @click="verifyPublish"
                        />
                        <input
                          type="button"
                          name="ctl00$ContentPlaceHolder1$btnReset"
                          value="Reset"
                          id="ContentPlaceHolder1_btnReset"
                          title="Reset this page"
                          formnovalidate="formnovalidate"
                          class="btn btn-soft-secondary"
                          @click="resetData"
                        />
                       
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="bytecode">
                    <h4 class="h5 mb-1">
                      Bytecode And ABI generated from Source Code
                    </h4>
                    <p class="ml-1">
                      <b>Compiler debug log:</b><br />
                      <span
                        id="ContentPlaceHolder1_litAdditionalContractInfo"
                      ></span>
                      <span id="ContentPlaceHolder1_lblResult"></span>
                    </p>
                    <br />
                    <p>
                      <a
                        id="ContentPlaceHolder1_linkStartOverButton"
                        class="btn btn-primary btn-sm"
                        href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$linkStartOverButton','')"
                        >Start Over</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <input
              type="hidden"
              name="ctl00$ContentPlaceHolder1$hdnSelectedTab"
              id="ContentPlaceHolder1_hdnSelectedTab"
              value="bytecode"
            />
            <input
              type="hidden"
              name="ctl00$ContentPlaceHolder1$libcounter"
              id="ContentPlaceHolder1_libcounter"
              value="1"
            />
          </form>
        </div>
      </main>
    </div>
    <comfooter></comfooter>
  </div>
</template>


<script>
import comheader from "@/components/serach_header";
import comfooter from "@/components/comfooter";
import $ from "jquery";
import "../assets/js/jqueryui.js";
// import "../assets/js/jquery-mig.js";

import "../assets/js/pop.js";

import "../assets/js/bootstrap.min.js";
import { upload_contract_source_code } from "@/API/api";
export default {
  data() {
    return {
      error_msg: "",
      error_code:0,
      twoIfShow: false,
      threeIfShow: false,
      address: "",
      selectedVersion: "",
      fileList: [],
      optValue: false,
      runValue: "0",
      evmVersion: "",
      licenseType: "No License (None)",
      libraryList: [
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
        { filename: "", l: "" },
      ],
    };
  },

  components: {
    comheader,
    comfooter,
  },

  async mounted() {
    let that = this;

    
    if (JSON.stringify(that.$route.params) != "{}") {
      that.address = that.$route.params.address;
      that.selectedVersion = that.$route.params.selectedVersion;
      sessionStorage.setItem("contract_addr", that.address);
      sessionStorage.setItem("selected_version", that.selectedVersion);
    } else {
      that.address = sessionStorage.getItem("contract_addr");
      that.selectedVersion = sessionStorage.getItem("selected_version");
    }
  },
  methods: {
    resetData() {
      let that = this;
      that.optValue = false;
      that.libraryList.forEach((item) => {
        item.filename = "";
        item.l = "";
      });
      that.runValue = "0";
      that.evmVersion = "";
      that.licenseType = "No License (None)";
 
      that.$refs.refFile.value = "";
      that.error_code = 0
      // location.reload()
    },
    fileLoad() {
      let that = this;
      const selectedFile = this.$refs.refFile.files;
      selectedFile.forEach((file) => {
        let obj = that.getFile(file);
        that.fileList.push(obj);
      });
 
    },
    getFile(file) {
      let filename = file.name;
      let obj = {};
      obj.filename = filename;

      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function () {
        obj.content = this.result;
      };

      return obj;
    },
    async verifyPublish() {
      let that = this;
      let o = {
        sources: [...that.fileList],
        evm_version: that.evmVersion,
        solc_version: that.selectedVersion,
        optimization: that.optValue,
        runs: that.runValue,
        input: "",
        contract_address: that.address,
        libraries: [
          ...that.libraryList.filter((item) => {
            return item.filename != "";
          }),
        ],
        liecense: that.licenseType,
      };

      let res = await upload_contract_source_code(JSON.stringify(o));
      that.error_code = res.code
      if (res.code == 500) {
        that.error_msg = res.message;
      }else{
        that.$router.push('/txs')
      }
    },
    twoShow() {
      let that = this;
      if (!that.twoIfShow) {
        setTimeout(() => {
          that.twoIfShow = true;
        }, 100);
      } else {
        setTimeout(() => {
          that.twoIfShow = false;
        }, 100);
      }
    },
    threeShow() {
      let that = this;
      if (!that.threeIfShow) {
        setTimeout(() => {
          that.threeIfShow = true;
        }, 100);
      } else {
        setTimeout(() => {
          that.threeIfShow = false;
        }, 100);
      }
    },
  },
};
</script>
<style scoped>
.none {
  display: none;
}
.bl {
  display: block;
}
</style>
